// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options, urlSearchParamsBodySerializer } from '@hey-api/client-fetch';
import type { ApiTokenAuthCreateData, ApiTokenAuthCreateError, ApiTokenAuthCreateResponse, ActiveAiAvatarVoicePresetListError, ActiveAiAvatarVoicePresetListResponse, ActiveAiAvatarVoicePresetRetrieveData, ActiveAiAvatarVoicePresetRetrieveError, ActiveAiAvatarVoicePresetRetrieveResponse, AdminMediaFoldersListData, AdminMediaFoldersListError, AdminMediaFoldersListResponse, AdminWorkspacesListData, AdminWorkspacesListError, AdminWorkspacesListResponse, AiAvatarListError, AiAvatarListResponse, AiAvatarRetrieveData, AiAvatarRetrieveError, AiAvatarRetrieveResponse, AiMediaModelsListError, AiMediaModelsListResponse, AiVoiceListError, AiVoiceListResponse, AiVoiceRetrieveData, AiVoiceRetrieveError, AiVoiceRetrieveResponse, ArticleImagesListData, ArticleImagesListError, ArticleImagesListResponse, ArticleImagesDestroyData, ArticleImagesDestroyError, ArticleImagesDestroyResponse, ArticleImagesDeleteAllDestroyData, ArticleImagesDeleteAllDestroyError, ArticleImagesDeleteAllDestroyResponse, ArticleRetrieveData, ArticleRetrieveError, ArticleRetrieveResponse, ArticleUpdateData, ArticleUpdateError, ArticleUpdateResponse, ArticlePartialUpdateData, ArticlePartialUpdateError, ArticlePartialUpdateResponse, ArticleReplaceUrlUpdateData, ArticleReplaceUrlUpdateError, ArticleReplaceUrlUpdateResponse, AssetAudioEnhancementRetrieveData, AssetAudioEnhancementRetrieveError, AssetAudioEnhancementRetrieveResponse, AssetDeletionGcsDestroyData, AssetDeletionGcsDestroyError, AssetDeletionGcsDestroyResponse, AssetSaveCreateData, AssetSaveCreateError, AssetSaveCreateResponse, AssetTranscriptRetrieveData, AssetTranscriptRetrieveError, AssetTranscriptRetrieveResponse, AssetValidationUpdateData, AssetValidationUpdateError, AssetValidationUpdateResponse, AsyncOperationResultRetrieveData, AsyncOperationResultRetrieveError, AsyncOperationResultRetrieveResponse, AsyncOperationsListData, AsyncOperationsListError, AsyncOperationsListResponse, AudioRetrieveData, AudioRetrieveError, AudioRetrieveResponse, AudioDestroyData, AudioDestroyError, AudioDestroyResponse, AudioassetRetrieveData, AudioassetRetrieveError, AudioassetRetrieveResponse, AuditLogListData, AuditLogListError, AuditLogListResponse, AuditLogExportCsvCreateError, AuditLogExportCsvCreateResponse, BackgroundAssetsDestroyData, BackgroundAssetsDestroyError, BackgroundAssetsDestroyResponse, BackgroundRemovalCreateData, BackgroundRemovalCreateError, BackgroundRemovalCreateResponse, BatchTextToVoiceoverCreateData, BatchTextToVoiceoverCreateError, BatchTextToVoiceoverCreateResponse, BillingChargesListError, BillingChargesListResponse, BillingPreferencesRetrieveError, BillingPreferencesRetrieveResponse, BillingPreferencesUpdateData, BillingPreferencesUpdateError, BillingPreferencesUpdateResponse, BillingSubscribersListError, BillingSubscribersListResponse, BillingSubscribersCreateData, BillingSubscribersCreateError, BillingSubscribersCreateResponse, BillingSubscribersDestroyData, BillingSubscribersDestroyError, BillingSubscribersDestroyResponse, BlueprintAutoPickCreateData, BlueprintAutoPickCreateError, BlueprintAutoPickCreateResponse, BlueprintsListData, BlueprintsListError, BlueprintsListResponse, BlueprintsRetrieveData, BlueprintsRetrieveError, BlueprintsRetrieveResponse, BlueprintsTemplateStyleVideoDataRetrieveData, BlueprintsTemplateStyleVideoDataRetrieveError, BlueprintsTemplateStyleVideoDataRetrieveResponse, BlueprintsVideoDataRetrieveData, BlueprintsVideoDataRetrieveError, BlueprintsVideoDataRetrieveResponse, BrandKitsListError, BrandKitsListResponse, BrandKitsCreateData, BrandKitsCreateError, BrandKitsCreateResponse, BrandKitsRetrieveData, BrandKitsRetrieveError, BrandKitsRetrieveResponse, BrandKitsUpdateData, BrandKitsUpdateError, BrandKitsUpdateResponse, BrandKitsDestroyData, BrandKitsDestroyError, BrandKitsDestroyResponse, BulkAssetSourceCreateData, BulkAssetSourceCreateError, BulkAssetSourceCreateResponse, BulkMediaAssetsListData, BulkMediaAssetsListError, BulkMediaAssetsListResponse, BulkTextSegmentationCreateData, BulkTextSegmentationCreateError, BulkTextSegmentationCreateResponse, BulkUploadUrlsCreateData, BulkUploadUrlsCreateError, BulkUploadUrlsCreateResponse, ChangePasswordCreateData, ChangePasswordCreateError, ChangePasswordCreateResponse, ChangeWorkspaceUpdateData, ChangeWorkspaceUpdateError, ChangeWorkspaceUpdateResponse, ChartStylesListError, ChartStylesListResponse, ClicklogsclickCreateData, ClicklogsclickCreateError, ClicklogsclickCreateResponse, ClicklogsqueryCreateData, ClicklogsqueryCreateError, ClicklogsqueryCreateResponse, ClicklogsrecommendationCreateData, ClicklogsrecommendationCreateError, ClicklogsrecommendationCreateResponse, ClipPlannerCreateData, ClipPlannerCreateError, ClipPlannerCreateResponse, ColorFilterListData, ColorFilterListError, ColorFilterListResponse, SaveConversationData, SaveConversationError, SaveConversationResponse, GetConversationData, GetConversationError, GetConversationResponse, CopyMediaAssetsCreateData, CopyMediaAssetsCreateError, CopyMediaAssetsCreateResponse, CustomBlueprintsListData, CustomBlueprintsListError, CustomBlueprintsListResponse, CustomBlueprintsCreateData, CustomBlueprintsCreateError, CustomBlueprintsCreateResponse, CustomBlueprintsRetrieveData, CustomBlueprintsRetrieveError, CustomBlueprintsRetrieveResponse, CustomBlueprintsPartialUpdateData, CustomBlueprintsPartialUpdateError, CustomBlueprintsPartialUpdateResponse, CustomBlueprintsDestroyData, CustomBlueprintsDestroyError, CustomBlueprintsDestroyResponse, CustomBlueprintsDuplicateCreateData, CustomBlueprintsDuplicateCreateError, CustomBlueprintsDuplicateCreateResponse, CustomBlueprintsCreateFromSimilarCreateData, CustomBlueprintsCreateFromSimilarCreateError, CustomBlueprintsCreateFromSimilarCreateResponse, CustomBlueprintsCreateFromSuggestedBlueprintCreateData, CustomBlueprintsCreateFromSuggestedBlueprintCreateError, CustomBlueprintsCreateFromSuggestedBlueprintCreateResponse, DamSearchCreateData, DamSearchCreateError, DamSearchCreateResponse, DatasetMetadataRetrieveData, DatasetMetadataRetrieveError, DatasetMetadataRetrieveResponse, DatasetMetadataUpdateData, DatasetMetadataUpdateError, DatasetMetadataUpdateResponse, DatasetMetadataPartialUpdateData, DatasetMetadataPartialUpdateError, DatasetMetadataPartialUpdateResponse, DocumentResetUpdateData, DocumentResetUpdateError, DocumentResetUpdateResponse, DocumentsCreateData, DocumentsCreateError, DocumentsCreateResponse, DocumentsImagesListData, DocumentsImagesListError, DocumentsImagesListResponse, DocumentsImagesDestroyData, DocumentsImagesDestroyError, DocumentsImagesDestroyResponse, DocumentsImagesDeleteAllDestroyData, DocumentsImagesDeleteAllDestroyError, DocumentsImagesDeleteAllDestroyResponse, DocumentsUpdateData, DocumentsUpdateError, DocumentsUpdateResponse, DocumentsPartialUpdateData, DocumentsPartialUpdateError, DocumentsPartialUpdateResponse, EditVoiceoverUpdateData, EditVoiceoverUpdateError, EditVoiceoverUpdateResponse, EmailExistsCreateData, EmailExistsCreateError, EmailExistsCreateResponse, FaceDetectionCreateData, FaceDetectionCreateError, FaceDetectionCreateResponse, FavoritesListMarkedFavoritesListData, FavoritesListMarkedFavoritesListError, FavoritesListMarkedFavoritesListResponse, FavoritesMarkFavoriteCreateData, FavoritesMarkFavoriteCreateError, FavoritesMarkFavoriteCreateResponse, FavoritesUnmarkFavoriteDestroyError, FavoritesUnmarkFavoriteDestroyResponse, FeedbackBetaCreateData, FeedbackBetaCreateError, FeedbackBetaCreateResponse, FetchArticleImageRetrieveData, FetchArticleImageRetrieveError, FetchArticleImageRetrieveResponse, FlagEnrollRetrieveData, FlagEnrollRetrieveError, FlagEnrollRetrieveResponse, FlagWithdrawRetrieveData, FlagWithdrawRetrieveError, FlagWithdrawRetrieveResponse, FlagListAllListError, FlagListAllListResponse, FontAssetsListError, FontAssetsListResponse, FontAssetsDestroyData, FontAssetsDestroyError, FontAssetsDestroyResponse, GenerateMediaCandidatesCreateData, GenerateMediaCandidatesCreateError, GenerateMediaCandidatesCreateResponse, GenerateScriptCreateData, GenerateScriptCreateError, GenerateScriptCreateResponse, GenerateScriptFromPromptCreateData, GenerateScriptFromPromptCreateError, GenerateScriptFromPromptCreateResponse, GenerateVideoRecommendationCreateData, GenerateVideoRecommendationCreateError, GenerateVideoRecommendationCreateResponse, GenerateVideosForVideoPlansCreateData, GenerateVideosForVideoPlansCreateError, GenerateVideosForVideoPlansCreateResponse, GetLanguageInfoForTextCreateData, GetLanguageInfoForTextCreateError, GetLanguageInfoForTextCreateResponse, ImageGenerationCreateData, ImageGenerationCreateError, ImageGenerationCreateResponse, InspirationCreateError, InspirationCreateResponse, IsAuthenticatedRetrieveError, IsAuthenticatedRetrieveResponse, LogMediaAgentResultsCreateData, LogMediaAgentResultsCreateError, LogMediaAgentResultsCreateResponse, LongestSupportedDurationTargetsCreateData, LongestSupportedDurationTargetsCreateError, LongestSupportedDurationTargetsCreateResponse, MediaAssetTextRepresentationRetrieveData, MediaAssetTextRepresentationRetrieveError, MediaAssetTextRepresentationRetrieveResponse, MediaFoldersListError, MediaFoldersListResponse, MediaFoldersCreateData, MediaFoldersCreateError, MediaFoldersCreateResponse, MediaFoldersRetrieveData, MediaFoldersRetrieveError, MediaFoldersRetrieveResponse, MediaFoldersPartialUpdateData, MediaFoldersPartialUpdateError, MediaFoldersPartialUpdateResponse, MediaFoldersDestroyData, MediaFoldersDestroyError, MediaFoldersDestroyResponse, MediaSearchCreateData, MediaSearchCreateError, MediaSearchCreateResponse, MergeTeamsCreateData, MergeTeamsCreateError, MergeTeamsCreateResponse, MixyCreateData, MixyCreateError, MixyCreateResponse, MusicRecommendationCreateData, MusicRecommendationCreateError, MusicRecommendationCreateResponse, MuteAudioCreateData, MuteAudioCreateError, MuteAudioCreateResponse, NameSuggestionCreateData, NameSuggestionCreateError, NameSuggestionCreateResponse, NotificationsListError, NotificationsListResponse, NotificationsMarkAsReadPartialUpdateData, NotificationsMarkAsReadPartialUpdateError, NotificationsMarkAsReadPartialUpdateResponse, NotificationsMarkAllAsReadPartialUpdateError, NotificationsMarkAllAsReadPartialUpdateResponse, NotificationsNumUnreadRetrieveError, NotificationsNumUnreadRetrieveResponse, PasswordForgotCreateData, PasswordForgotCreateError, PasswordForgotCreateResponse, PasswordResetCreateData, PasswordResetCreateError, PasswordResetCreateResponse, PrefetchMediaCandidatesCreateData, PrefetchMediaCandidatesCreateError, PrefetchMediaCandidatesCreateResponse, PremiumMediaCreditCheckCreateData, PremiumMediaCreditCheckCreateError, PremiumMediaCreditCheckCreateResponse, PricingCancellationFeedbackCreateData, PricingCancellationFeedbackCreateError, PricingCancellationFeedbackCreateResponse, PricingCreditCardDetailsRetrieveError, PricingCreditCardDetailsRetrieveResponse, PricingCurrentPlanNameRetrieveError, PricingCurrentPlanNameRetrieveResponse, PricingPaymentMethodCheckoutUpdateData, PricingPaymentMethodCheckoutUpdateError, PricingPaymentMethodCheckoutUpdateResponse, PricingPaymentMethodStatusRetrieveError, PricingPaymentMethodStatusRetrieveResponse, PricingPlansRetrieveData, PricingPlansRetrieveError, PricingPlansRetrieveResponse, PricingPremiumMediaRetrieveError, PricingPremiumMediaRetrieveResponse, PricingRenewSubscriptionCreateError, PricingRenewSubscriptionCreateResponse, PricingSubscriptionRetrieveError, PricingSubscriptionRetrieveResponse, PricingSubscriptionCreateData, PricingSubscriptionCreateError, PricingSubscriptionCreateResponse, PricingSubscriptionPartialUpdateData, PricingSubscriptionPartialUpdateError, PricingSubscriptionPartialUpdateResponse, PricingSubscriptionPauseCreateData, PricingSubscriptionPauseCreateError, PricingSubscriptionPauseCreateResponse, PricingSubscriptionResumeCreateError, PricingSubscriptionResumeCreateResponse, ProjectsListError, ProjectsListResponse, ProjectsCreateData, ProjectsCreateError, ProjectsCreateResponse, ProjectsRetrieveData, ProjectsRetrieveError, ProjectsRetrieveResponse, ProjectsPartialUpdateData, ProjectsPartialUpdateError, ProjectsPartialUpdateResponse, ProjectsDestroyData, ProjectsDestroyError, ProjectsDestroyResponse, PronunciationListError, PronunciationListResponse, PronunciationUpsertData, PronunciationUpsertError, PronunciationUpsertResponse, PronunciationDestroyData, PronunciationDestroyError, PronunciationDestroyResponse, PublicBlueprintsListData, PublicBlueprintsListError, PublicBlueprintsListResponse, PublicBlueprintsCreateData, PublicBlueprintsCreateError, PublicBlueprintsCreateResponse, PublicBlueprintsRetrieveData, PublicBlueprintsRetrieveError, PublicBlueprintsRetrieveResponse, PublicBlueprintsPartialUpdateData, PublicBlueprintsPartialUpdateError, PublicBlueprintsPartialUpdateResponse, PublicBlueprintsDestroyData, PublicBlueprintsDestroyError, PublicBlueprintsDestroyResponse, PublicVideoRetrieveData, PublicVideoRetrieveError, PublicVideoRetrieveResponse, QueueEstimatedRenderDurationRetrieveError, QueueEstimatedRenderDurationRetrieveResponse, QueueVideoRenderDetailsRetrieveData, QueueVideoRenderDetailsRetrieveError, QueueVideoRenderDetailsRetrieveResponse, RecentlyUsedTemplatesListError, RecentlyUsedTemplatesListResponse, RegenerateTranscriptForAssetCreateData, RegenerateTranscriptForAssetCreateError, RegenerateTranscriptForAssetCreateResponse, RegenerateMfaBackupKeysCreateError, RegenerateMfaBackupKeysCreateResponse, ResolveCommentsCreateData, ResolveCommentsCreateError, ResolveCommentsCreateResponse, RssFeedsListData, RssFeedsListError, RssFeedsListResponse, RssFeedsCreateData, RssFeedsCreateError, RssFeedsCreateResponse, RssFeedsUpdateData, RssFeedsUpdateError, RssFeedsUpdateResponse, RssFeedsEntriesListData, RssFeedsEntriesListError, RssFeedsEntriesListResponse, SaveVideoDataSnapshotCreateData, SaveVideoDataSnapshotCreateError, SaveVideoDataSnapshotCreateResponse, SceneAttributesListData, SceneAttributesListError, SceneAttributesListResponse, SceneDesignsListData, SceneDesignsListError, SceneDesignsListResponse, SceneDesignsCreateData, SceneDesignsCreateError, SceneDesignsCreateResponse, SceneDesignsRetrieveData, SceneDesignsRetrieveError, SceneDesignsRetrieveResponse, SceneDesignsUpdateData, SceneDesignsUpdateError, SceneDesignsUpdateResponse, SceneDesignsPartialUpdateData, SceneDesignsPartialUpdateError, SceneDesignsPartialUpdateResponse, SceneDesignsDestroyData, SceneDesignsDestroyError, SceneDesignsDestroyResponse, SceneDesignsBulkUpdateUpdateData, SceneDesignsBulkUpdateUpdateError, SceneDesignsBulkUpdateUpdateResponse, SceneDesignsIdsPerTemplateListError, SceneDesignsIdsPerTemplateListResponse, SceneDesignsTemplateAnnotationsRetrieveData, SceneDesignsTemplateAnnotationsRetrieveError, SceneDesignsTemplateAnnotationsRetrieveResponse, ScriptOptionsCreateData, ScriptOptionsCreateError, ScriptOptionsCreateResponse, SendEmailVerificationCreateData, SendEmailVerificationCreateError, SendEmailVerificationCreateResponse, SendMfaRecoveryCodeCreateData, SendMfaRecoveryCodeCreateError, SendMfaRecoveryCodeCreateResponse, SendSceneCommentMentionEmailCreateData, SendSceneCommentMentionEmailCreateError, SendSceneCommentMentionEmailCreateResponse, ShareGptFeedbackCreateData, ShareGptFeedbackCreateError, ShareGptFeedbackCreateResponse, SimpleTextCorrectionCreateData, SimpleTextCorrectionCreateError, SimpleTextCorrectionCreateResponse, SketchContextInfoRetrieveError, SketchContextInfoRetrieveResponse, SketchResearchCreateData, SketchResearchCreateError, SketchResearchCreateResponse, SketchUrlFetchCreateData, SketchUrlFetchCreateError, SketchUrlFetchCreateResponse, SketchValidateVideoPlansCreateData, SketchValidateVideoPlansCreateError, SketchValidateVideoPlansCreateResponse, SketchWebImageSearchCreateData, SketchWebImageSearchCreateError, SketchWebImageSearchCreateResponse, SsoIdpConfigCreateData, SsoIdpConfigCreateError, SsoIdpConfigCreateResponse, SsoIdpConfigRetrieveData, SsoIdpConfigRetrieveError, SsoIdpConfigRetrieveResponse, SsoIdpConfigUpdateData, SsoIdpConfigUpdateError, SsoIdpConfigUpdateResponse, SsoIdpConfigPartialUpdateData, SsoIdpConfigPartialUpdateError, SsoIdpConfigPartialUpdateResponse, SsoIdpConfigDestroyData, SsoIdpConfigDestroyError, SsoIdpConfigDestroyResponse, SsoVerficationCreateData, SsoVerficationCreateError, SsoVerficationCreateResponse, SubmitFeedbackCreateData, SubmitFeedbackCreateError, SubmitFeedbackCreateResponse, SuggestedBlueprintsListError, SuggestedBlueprintsListResponse, SuggestedBlueprintsRetrieveData, SuggestedBlueprintsRetrieveError, SuggestedBlueprintsRetrieveResponse, SuggestedMediaCreateData, SuggestedMediaCreateError, SuggestedMediaCreateResponse, SupportedLanguagesListError, SupportedLanguagesListResponse, TaskResultRetrieveData, TaskResultRetrieveError, TaskResultRetrieveResponse, TaskResultDestroyData, TaskResultDestroyError, TaskResultDestroyResponse, TaskResultsListData, TaskResultsListError, TaskResultsListResponse, TeamInvitationsListError, TeamInvitationsListResponse, TeamInvitationsCreateData, TeamInvitationsCreateError, TeamInvitationsCreateResponse, TeamInvitationsRetrieveData, TeamInvitationsRetrieveError, TeamInvitationsRetrieveResponse, TeamInvitationsDestroyData, TeamInvitationsDestroyError, TeamInvitationsDestroyResponse, TeamInvitationsResendCreateData, TeamInvitationsResendCreateError, TeamInvitationsResendCreateResponse, TeamMembersListError, TeamMembersListResponse, TeamMembersUpdateData, TeamMembersUpdateError, TeamMembersUpdateResponse, TeamMembersPartialUpdateData, TeamMembersPartialUpdateError, TeamMembersPartialUpdateResponse, TeamMembersDestroyData, TeamMembersDestroyError, TeamMembersDestroyResponse, TeamMembersDeleteUserAccountDestroyData, TeamMembersDeleteUserAccountDestroyError, TeamMembersDeleteUserAccountDestroyResponse, TeamMembersTwoFactorAuthenticationRetrieveError, TeamMembersTwoFactorAuthenticationRetrieveResponse, TeamMembersTwoFactorAuthenticationCreateData, TeamMembersTwoFactorAuthenticationCreateError, TeamMembersTwoFactorAuthenticationCreateResponse, TeamSettingsRetrieveError, TeamSettingsRetrieveResponse, TeamSettingsPartialUpdateData, TeamSettingsPartialUpdateError, TeamSettingsPartialUpdateResponse, TemplateCategoriesListError, TemplateCategoriesListResponse, TemplateInfoListData, TemplateInfoListError, TemplateInfoListResponse, TemplatesListError, TemplatesListResponse, TemplatesCreateData, TemplatesCreateError, TemplatesCreateResponse, TemplatesRetrieveData, TemplatesRetrieveError, TemplatesRetrieveResponse, TemplatesUpdateData, TemplatesUpdateError, TemplatesUpdateResponse, TemplatesPartialUpdateData, TemplatesPartialUpdateError, TemplatesPartialUpdateResponse, TemplatesDestroyData, TemplatesDestroyError, TemplatesDestroyResponse, TemplatesDisplayGroupsListData, TemplatesDisplayGroupsListError, TemplatesDisplayGroupsListResponse, TemplatesDisplayGroupsCreateData, TemplatesDisplayGroupsCreateError, TemplatesDisplayGroupsCreateResponse, TemplatesDisplayGroupsRetrieveData, TemplatesDisplayGroupsRetrieveError, TemplatesDisplayGroupsRetrieveResponse, TemplatesDisplayGroupsPartialUpdateData, TemplatesDisplayGroupsPartialUpdateError, TemplatesDisplayGroupsPartialUpdateResponse, TemplatesDisplayGroupsOrderPartialUpdateData, TemplatesDisplayGroupsOrderPartialUpdateError, TemplatesDisplayGroupsOrderPartialUpdateResponse, TextToVoiceoverAssetCreateData, TextToVoiceoverAssetCreateError, TextToVoiceoverAssetCreateResponse, TextTranslateCreateData, TextTranslateCreateError, TextTranslateCreateResponse, TopUploadsTagsRetrieveData, TopUploadsTagsRetrieveError, TopUploadsTagsRetrieveResponse, TranscriptClipCreateData, TranscriptClipCreateError, TranscriptClipCreateResponse, TransitionedAssetErrorCreateData, TransitionedAssetErrorCreateError, TransitionedAssetErrorCreateResponse, TransmogVideoCreateData, TransmogVideoCreateError, TransmogVideoCreateResponse, UploadUrlsCreateData, UploadUrlsCreateError, UploadUrlsCreateResponse, UploadsMetadataUpdateUpdateData, UploadsMetadataUpdateUpdateError, UploadsMetadataUpdateUpdateResponse, UsageLimitsRetrieveData, UsageLimitsRetrieveError, UsageLimitsRetrieveResponse, UsedTemplatesRetrieveError, UsedTemplatesRetrieveResponse, UserRetrieveError, UserRetrieveResponse, UserExtraDataCreateData, UserExtraDataCreateError, UserExtraDataCreateResponse, UserHasValidProjectInWorkspaceRetrieveError, UserHasValidProjectInWorkspaceRetrieveResponse, UserNotificationsRetrieveData, UserNotificationsRetrieveError, UserNotificationsRetrieveResponse, UserNotificationsPartialUpdateData, UserNotificationsPartialUpdateError, UserNotificationsPartialUpdateResponse, ValidateDatasetVideoRetrieveData, ValidateDatasetVideoRetrieveError, ValidateDatasetVideoRetrieveResponse, VideoListData, VideoListError, VideoListResponse, VideoCreateData, VideoCreateError, VideoCreateResponse, VideoApprovalStatusRetrieveData, VideoApprovalStatusRetrieveError, VideoApprovalStatusRetrieveResponse, VideoApprovalStatusUpdateData, VideoApprovalStatusUpdateError, VideoApprovalStatusUpdateResponse, VideoApprovalStatusPartialUpdateData, VideoApprovalStatusPartialUpdateError, VideoApprovalStatusPartialUpdateResponse, VideoCommentListData, VideoCommentListError, VideoCommentListResponse, VideoCommentCreateData, VideoCommentCreateError, VideoCommentCreateResponse, VideoCommentDestroyData, VideoCommentDestroyError, VideoCommentDestroyResponse, VideoGenerationCreateData, VideoGenerationCreateError, VideoGenerationCreateResponse, VideoPosterValidationUpdateData, VideoPosterValidationUpdateError, VideoPosterValidationUpdateResponse, VideoUploadGenxStoryboardCreateData, VideoUploadGenxStoryboardCreateError, VideoUploadGenxStoryboardCreateResponse, VideoRetrieveData, VideoRetrieveError, VideoRetrieveResponse, VideoUpdateData, VideoUpdateError, VideoUpdateResponse, VideoPartialUpdateData, VideoPartialUpdateError, VideoPartialUpdateResponse, VideoGroundhogAnalysisCreateData, VideoGroundhogAnalysisCreateError, VideoGroundhogAnalysisCreateResponse, VideoShareDownloadRetrieveData, VideoShareDownloadRetrieveError, VideoShareDownloadRetrieveResponse, VideoShareDownloadCreateData, VideoShareDownloadCreateError, VideoShareDownloadCreateResponse, VideoTextAssetsTranslateCreateData, VideoTextAssetsTranslateCreateError, VideoTextAssetsTranslateCreateResponse, VideoTranslatedTextListData, VideoTranslatedTextListError, VideoTranslatedTextListResponse, VideosRestoreCreateData, VideosRestoreCreateError, VideosRestoreCreateResponse, VideosVersionsRetrieveData, VideosVersionsRetrieveError, VideosVersionsRetrieveResponse, VideosVersionsRetrieve2Data, VideosVersionsRetrieve2Error, VideosVersionsRetrieve2Response, VideosArchiveMultipleVideosUpdateData, VideosArchiveMultipleVideosUpdateError, VideosArchiveMultipleVideosUpdateResponse, VideosBulkPublishCreateData, VideosBulkPublishCreateError, VideosBulkPublishCreateResponse, VideosCreateFromBlueprintCreateData, VideosCreateFromBlueprintCreateError, VideosCreateFromBlueprintCreateResponse, VideosDuplicateVideosCreateData, VideosDuplicateVideosCreateError, VideosDuplicateVideosCreateResponse, VideosMoveVideosPartialUpdateData, VideosMoveVideosPartialUpdateError, VideosMoveVideosPartialUpdateResponse, WorkspaceListError, WorkspaceListResponse, WorkspaceCreateData, WorkspaceCreateError, WorkspaceCreateResponse, WorkspaceVideoTagsRetrieveError, WorkspaceVideoTagsRetrieveResponse, WorkspaceRetrieveData, WorkspaceRetrieveError, WorkspaceRetrieveResponse, WorkspacePartialUpdateData, WorkspacePartialUpdateError, WorkspacePartialUpdateResponse, WorkspaceDestroyData, WorkspaceDestroyError, WorkspaceDestroyResponse, WorkspaceAddMembersCreateData, WorkspaceAddMembersCreateError, WorkspaceAddMembersCreateResponse, WorkspaceAnalyticsRetrieveData, WorkspaceAnalyticsRetrieveError, WorkspaceAnalyticsRetrieveResponse, WorkspaceRemoveMemberDestroyData, WorkspaceRemoveMemberDestroyError, WorkspaceRemoveMemberDestroyResponse, AuthInvitationRetrieveData, AuthInvitationRetrieveError, AuthInvitationRetrieveResponse, RenderVideoRenderDataRetrieveData, RenderVideoRenderDataRetrieveError, RenderVideoRenderDataRetrieveResponse } from './types.gen';

export const client = createClient(createConfig());

export class ApiService {
    public static apiTokenAuthCreate<ThrowOnError extends boolean = true>(options: Options<ApiTokenAuthCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ApiTokenAuthCreateResponse, ApiTokenAuthCreateError, ThrowOnError>({
            ...options,
            ...urlSearchParamsBodySerializer,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...options?.headers
            },
            url: '/api-token-auth/'
        });
    }
    
    public static activeAiAvatarVoicePresetList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<ActiveAiAvatarVoicePresetListResponse, ActiveAiAvatarVoicePresetListError, ThrowOnError>({
            ...options,
            url: '/api/active-ai-avatar-voice-preset/'
        });
    }
    
    public static activeAiAvatarVoicePresetRetrieve<ThrowOnError extends boolean = true>(options: Options<ActiveAiAvatarVoicePresetRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<ActiveAiAvatarVoicePresetRetrieveResponse, ActiveAiAvatarVoicePresetRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/active-ai-avatar-voice-preset/{id}/'
        });
    }
    
    public static adminMediaFoldersList<ThrowOnError extends boolean = true>(options: Options<AdminMediaFoldersListData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminMediaFoldersListResponse, AdminMediaFoldersListError, ThrowOnError>({
            ...options,
            url: '/api/admin/media-folders/{workspace_id}/'
        });
    }
    
    public static adminWorkspacesList<ThrowOnError extends boolean = true>(options: Options<AdminWorkspacesListData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminWorkspacesListResponse, AdminWorkspacesListError, ThrowOnError>({
            ...options,
            url: '/api/admin/workspaces/{team_id}/'
        });
    }
    
    /**
     * A simple ViewSet for viewing available ai_avatars
     */
    public static aiAvatarList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<AiAvatarListResponse, AiAvatarListError, ThrowOnError>({
            ...options,
            url: '/api/ai-avatar/'
        });
    }
    
    /**
     * A simple ViewSet for viewing available ai_avatars
     */
    public static aiAvatarRetrieve<ThrowOnError extends boolean = true>(options: Options<AiAvatarRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AiAvatarRetrieveResponse, AiAvatarRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/ai-avatar/{id}/'
        });
    }
    
    public static aiMediaModelsList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<AiMediaModelsListResponse, AiMediaModelsListError, ThrowOnError>({
            ...options,
            url: '/api/ai-media-models/'
        });
    }
    
    /**
     * A simple ViewSet for viewing available ai_voices
     */
    public static aiVoiceList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<AiVoiceListResponse, AiVoiceListError, ThrowOnError>({
            ...options,
            url: '/api/ai-voice/'
        });
    }
    
    /**
     * A simple ViewSet for viewing available ai_voices
     */
    public static aiVoiceRetrieve<ThrowOnError extends boolean = true>(options: Options<AiVoiceRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AiVoiceRetrieveResponse, AiVoiceRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/ai-voice/{id}/'
        });
    }
    
    public static articleImagesList<ThrowOnError extends boolean = true>(options: Options<ArticleImagesListData, ThrowOnError>) {
        return (options?.client ?? client).get<ArticleImagesListResponse, ArticleImagesListError, ThrowOnError>({
            ...options,
            url: '/api/article/{article_pk}/images/'
        });
    }
    
    public static articleImagesDestroy<ThrowOnError extends boolean = true>(options: Options<ArticleImagesDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<ArticleImagesDestroyResponse, ArticleImagesDestroyError, ThrowOnError>({
            ...options,
            url: '/api/article/{article_pk}/images/{id}/'
        });
    }
    
    public static articleImagesDeleteAllDestroy<ThrowOnError extends boolean = true>(options: Options<ArticleImagesDeleteAllDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<ArticleImagesDeleteAllDestroyResponse, ArticleImagesDeleteAllDestroyError, ThrowOnError>({
            ...options,
            url: '/api/article/{article_pk}/images/delete_all/'
        });
    }
    
    public static articleRetrieve<ThrowOnError extends boolean = true>(options: Options<ArticleRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<ArticleRetrieveResponse, ArticleRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/article/{id}/'
        });
    }
    
    public static articleUpdate<ThrowOnError extends boolean = true>(options: Options<ArticleUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<ArticleUpdateResponse, ArticleUpdateError, ThrowOnError>({
            ...options,
            url: '/api/article/{id}/'
        });
    }
    
    public static articlePartialUpdate<ThrowOnError extends boolean = true>(options: Options<ArticlePartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<ArticlePartialUpdateResponse, ArticlePartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/article/{id}/'
        });
    }
    
    public static articleReplaceUrlUpdate<ThrowOnError extends boolean = true>(options: Options<ArticleReplaceUrlUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<ArticleReplaceUrlUpdateResponse, ArticleReplaceUrlUpdateError, ThrowOnError>({
            ...options,
            url: '/api/article/{id}/replace_url/'
        });
    }
    
    /**
     * Attempts to retrieve the asset with the specified asset_type, asset_source, and asset_source_id
     * If the asset is found, we return the serialized asset data
     * Else, we retrieve the user uploaded asset with matching source_id, get the asset_uuid, and lookup AsyncOperation
     * table for a pending audio enhancement job.
     * If an async audio enhancement job exists, we return the async_operation_uuid to the frontend for polling.
     * Else, we create an audio enhancement job and return the newly created async_operation_uuid to the frontend for polling.
     *
     * If the original asset is not found, we return a generic error.
     */
    public static assetAudioEnhancementRetrieve<ThrowOnError extends boolean = true>(options: Options<AssetAudioEnhancementRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AssetAudioEnhancementRetrieveResponse, AssetAudioEnhancementRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/asset-audio-enhancement/'
        });
    }
    
    /**
     * Triggers the task to delete an asset (defined by its urls) from GCS
     * Params:
     * - urls: the urls to delete from GCS
     */
    public static assetDeletionGcsDestroy<ThrowOnError extends boolean = true>(options: Options<AssetDeletionGcsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<AssetDeletionGcsDestroyResponse, AssetDeletionGcsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/asset-deletion-gcs/'
        });
    }
    
    /**
     * Triggers the task to validate and save an asset
     */
    public static assetSaveCreate<ThrowOnError extends boolean = true>(options: Options<AssetSaveCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<AssetSaveCreateResponse, AssetSaveCreateError, ThrowOnError>({
            ...options,
            url: '/api/asset-save/'
        });
    }
    
    public static assetTranscriptRetrieve<ThrowOnError extends boolean = true>(options: Options<AssetTranscriptRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AssetTranscriptRetrieveResponse, AssetTranscriptRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/asset-transcript/{asset_id}/'
        });
    }
    
    /**
     * Triggers the task to validate an asset, along with asset metadata.
     * Params:
     *
     * - bucket: the name of the bucket used
     * - file_name: the filename to validate inside of the bucket
     * - user_file_name: the original filename of the asset
     * - metadata: associated metadata to validate (attribution, license,
     * and other stuff saved in the models and common to all assets)
     * - add_to_user_library: "true" or "false", whether this upload should
     * be searchable by the user in the future (should be false
     * for branding assets)
     * - only_images: "true" of "false", whether we should only accept
     * images as valid files
     * - only_audio: "true" of "false", whether we should only accept
     * audio as valid files
     */
    public static assetValidationUpdate<ThrowOnError extends boolean = true>(options: Options<AssetValidationUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<AssetValidationUpdateResponse, AssetValidationUpdateError, ThrowOnError>({
            ...options,
            url: '/api/asset-validation/'
        });
    }
    
    /**
     * Get the result of the async operation. Instead of getting the
     * result from the task, this endpoint will look at the AsyncOperation model
     */
    public static asyncOperationResultRetrieve<ThrowOnError extends boolean = true>(options: Options<AsyncOperationResultRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AsyncOperationResultRetrieveResponse, AsyncOperationResultRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/async-operation-result/{async_operation_uuid}/'
        });
    }
    
    public static asyncOperationsList<ThrowOnError extends boolean = true>(options?: Options<AsyncOperationsListData, ThrowOnError>) {
        return (options?.client ?? client).get<AsyncOperationsListResponse, AsyncOperationsListError, ThrowOnError>({
            ...options,
            url: '/api/async-operations/'
        });
    }
    
    /**
     * Return a list of assets that we can use as the background track to videos.
     * Params:
     *
     * - q: the search term
     * - page: the page number requested
     * - count: the number of results per page
     * - source: if we should search uploads or the audio library (uploads or cc)
     */
    public static audioRetrieve<ThrowOnError extends boolean = true>(options: Options<AudioRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AudioRetrieveResponse, AudioRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/audio/'
        });
    }
    
    /**
     * Archives an uploaded audio asset
     * - id: the id of the audio asset in our DB
     */
    public static audioDestroy<ThrowOnError extends boolean = true>(options: Options<AudioDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<AudioDestroyResponse, AudioDestroyError, ThrowOnError>({
            ...options,
            url: '/api/audio/'
        });
    }
    
    public static audioassetRetrieve<ThrowOnError extends boolean = true>(options: Options<AudioassetRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AudioassetRetrieveResponse, AudioassetRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/audioasset/{uuid}/'
        });
    }
    
    public static auditLogList<ThrowOnError extends boolean = true>(options?: Options<AuditLogListData, ThrowOnError>) {
        return (options?.client ?? client).get<AuditLogListResponse, AuditLogListError, ThrowOnError>({
            ...options,
            url: '/api/audit-log/'
        });
    }
    
    public static auditLogExportCsvCreate<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).post<AuditLogExportCsvCreateResponse, AuditLogExportCsvCreateError, ThrowOnError>({
            ...options,
            url: '/api/audit-log/export_csv/'
        });
    }
    
    /**
     * 'Deletes' a background asset by setting the archived flag on the asset.
     * This is implemented to only work for user uploaded background assets. Params:
     *
     * - type: the background asset type (image or video)
     * - id: the id of the asset
     */
    public static backgroundAssetsDestroy<ThrowOnError extends boolean = true>(options: Options<BackgroundAssetsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<BackgroundAssetsDestroyResponse, BackgroundAssetsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/background-assets/'
        });
    }
    
    public static backgroundRemovalCreate<ThrowOnError extends boolean = true>(options: Options<BackgroundRemovalCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<BackgroundRemovalCreateResponse, BackgroundRemovalCreateError, ThrowOnError>({
            ...options,
            url: '/api/background-removal/'
        });
    }
    
    public static batchTextToVoiceoverCreate<ThrowOnError extends boolean = true>(options: Options<BatchTextToVoiceoverCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<BatchTextToVoiceoverCreateResponse, BatchTextToVoiceoverCreateError, ThrowOnError>({
            ...options,
            url: '/api/batch_text_to_voiceover/'
        });
    }
    
    /**
     * list of charges & their details
     */
    public static billingChargesList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<BillingChargesListResponse, BillingChargesListError, ThrowOnError>({
            ...options,
            url: '/api/billing/charges/'
        });
    }
    
    /**
     * modify and set team billing preferences
     */
    public static billingPreferencesRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<BillingPreferencesRetrieveResponse, BillingPreferencesRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/billing/preferences/'
        });
    }
    
    /**
     * modify and set team billing preferences
     */
    public static billingPreferencesUpdate<ThrowOnError extends boolean = true>(options?: Options<BillingPreferencesUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<BillingPreferencesUpdateResponse, BillingPreferencesUpdateError, ThrowOnError>({
            ...options,
            url: '/api/billing/preferences/'
        });
    }
    
    /**
     * fetch, create, and delete receipt subscribers
     */
    public static billingSubscribersList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<BillingSubscribersListResponse, BillingSubscribersListError, ThrowOnError>({
            ...options,
            url: '/api/billing/subscribers/'
        });
    }
    
    /**
     * fetch, create, and delete receipt subscribers
     */
    public static billingSubscribersCreate<ThrowOnError extends boolean = true>(options: Options<BillingSubscribersCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<BillingSubscribersCreateResponse, BillingSubscribersCreateError, ThrowOnError>({
            ...options,
            url: '/api/billing/subscribers/'
        });
    }
    
    /**
     * fetch, create, and delete receipt subscribers
     */
    public static billingSubscribersDestroy<ThrowOnError extends boolean = true>(options: Options<BillingSubscribersDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<BillingSubscribersDestroyResponse, BillingSubscribersDestroyError, ThrowOnError>({
            ...options,
            url: '/api/billing/subscribers/{id}/'
        });
    }
    
    /**
     * This endpoint automatically selects the best public blueprint for a video based on input source content.
     */
    public static blueprintAutoPickCreate<ThrowOnError extends boolean = true>(options: Options<BlueprintAutoPickCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<BlueprintAutoPickCreateResponse, BlueprintAutoPickCreateError, ThrowOnError>({
            ...options,
            url: '/api/blueprint-auto-pick/'
        });
    }
    
    /**
     * Viewset for customer AND public blueprints.
     * Useful when retrieving blueprints we don't know are public or custom.
     * Does not support creating/editing blueprints, just read operations.
     */
    public static blueprintsList<ThrowOnError extends boolean = true>(options?: Options<BlueprintsListData, ThrowOnError>) {
        return (options?.client ?? client).get<BlueprintsListResponse, BlueprintsListError, ThrowOnError>({
            ...options,
            url: '/api/blueprints/'
        });
    }
    
    /**
     * Viewset for customer AND public blueprints.
     * Useful when retrieving blueprints we don't know are public or custom.
     * Does not support creating/editing blueprints, just read operations.
     */
    public static blueprintsRetrieve<ThrowOnError extends boolean = true>(options: Options<BlueprintsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<BlueprintsRetrieveResponse, BlueprintsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/blueprints/{id}/'
        });
    }
    
    /**
     * Viewset for customer AND public blueprints.
     * Useful when retrieving blueprints we don't know are public or custom.
     * Does not support creating/editing blueprints, just read operations.
     */
    public static blueprintsTemplateStyleVideoDataRetrieve<ThrowOnError extends boolean = true>(options: Options<BlueprintsTemplateStyleVideoDataRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<BlueprintsTemplateStyleVideoDataRetrieveResponse, BlueprintsTemplateStyleVideoDataRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/blueprints/{id}/template-style-video-data/'
        });
    }
    
    /**
     * Fetch video_data for multiple blueprints by ID.
     * Used to generate Luminary previews for blueprints that don't have poster_url.
     * Works for both custom and public blueprints.
     */
    public static blueprintsVideoDataRetrieve<ThrowOnError extends boolean = true>(options: Options<BlueprintsVideoDataRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<BlueprintsVideoDataRetrieveResponse, BlueprintsVideoDataRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/blueprints/video-data/'
        });
    }
    
    public static brandKitsList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<BrandKitsListResponse, BrandKitsListError, ThrowOnError>({
            ...options,
            url: '/api/brand-kits/'
        });
    }
    
    public static brandKitsCreate<ThrowOnError extends boolean = true>(options: Options<BrandKitsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<BrandKitsCreateResponse, BrandKitsCreateError, ThrowOnError>({
            ...options,
            url: '/api/brand-kits/'
        });
    }
    
    public static brandKitsRetrieve<ThrowOnError extends boolean = true>(options: Options<BrandKitsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<BrandKitsRetrieveResponse, BrandKitsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/brand-kits/{id}/'
        });
    }
    
    public static brandKitsUpdate<ThrowOnError extends boolean = true>(options: Options<BrandKitsUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<BrandKitsUpdateResponse, BrandKitsUpdateError, ThrowOnError>({
            ...options,
            url: '/api/brand-kits/{id}/'
        });
    }
    
    public static brandKitsDestroy<ThrowOnError extends boolean = true>(options: Options<BrandKitsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<BrandKitsDestroyResponse, BrandKitsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/brand-kits/{id}/'
        });
    }
    
    public static bulkAssetSourceCreate<ThrowOnError extends boolean = true>(options: Options<BulkAssetSourceCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<BulkAssetSourceCreateResponse, BulkAssetSourceCreateError, ThrowOnError>({
            ...options,
            url: '/api/bulk-asset-source/'
        });
    }
    
    /**
     * This endpoint is used to retrieve asset details in bulk for assets by UUID.
     */
    public static bulkMediaAssetsList<ThrowOnError extends boolean = true>(options?: Options<BulkMediaAssetsListData, ThrowOnError>) {
        return (options?.client ?? client).get<BulkMediaAssetsListResponse, BulkMediaAssetsListError, ThrowOnError>({
            ...options,
            url: '/api/bulk-media-assets/'
        });
    }
    
    public static bulkTextSegmentationCreate<ThrowOnError extends boolean = true>(options: Options<BulkTextSegmentationCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<BulkTextSegmentationCreateResponse, BulkTextSegmentationCreateError, ThrowOnError>({
            ...options,
            url: '/api/bulk-text-segmentation/'
        });
    }
    
    /**
     * Creates resumable upload sessions for multiple files to the user's gcs bucket.
     */
    public static bulkUploadUrlsCreate<ThrowOnError extends boolean = true>(options: Options<BulkUploadUrlsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<BulkUploadUrlsCreateResponse, BulkUploadUrlsCreateError, ThrowOnError>({
            ...options,
            url: '/api/bulk-upload-urls/'
        });
    }
    
    public static changePasswordCreate<ThrowOnError extends boolean = true>(options: Options<ChangePasswordCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ChangePasswordCreateResponse, ChangePasswordCreateError, ThrowOnError>({
            ...options,
            url: '/api/change-password/'
        });
    }
    
    /**
     * Changes the user's current active workspace
     */
    public static changeWorkspaceUpdate<ThrowOnError extends boolean = true>(options: Options<ChangeWorkspaceUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<ChangeWorkspaceUpdateResponse, ChangeWorkspaceUpdateError, ThrowOnError>({
            ...options,
            url: '/api/change-workspace/{workspace_id}/'
        });
    }
    
    /**
     * Returns chart style assets for the given chart type.
     * These are system assets (user=None) that serve as style references for AI chart generation.
     */
    public static chartStylesList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<ChartStylesListResponse, ChartStylesListError, ThrowOnError>({
            ...options,
            url: '/api/chart-styles/'
        });
    }
    
    public static clicklogsclickCreate<ThrowOnError extends boolean = true>(options: Options<ClicklogsclickCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ClicklogsclickCreateResponse, ClicklogsclickCreateError, ThrowOnError>({
            ...options,
            url: '/api/clicklogsclick/'
        });
    }
    
    public static clicklogsqueryCreate<ThrowOnError extends boolean = true>(options: Options<ClicklogsqueryCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ClicklogsqueryCreateResponse, ClicklogsqueryCreateError, ThrowOnError>({
            ...options,
            url: '/api/clicklogsquery/'
        });
    }
    
    public static clicklogsrecommendationCreate<ThrowOnError extends boolean = true>(options: Options<ClicklogsrecommendationCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ClicklogsrecommendationCreateResponse, ClicklogsrecommendationCreateError, ThrowOnError>({
            ...options,
            url: '/api/clicklogsrecommendation/'
        });
    }
    
    /**
     * This endpoint generates a list of "clip plan" options given some uploaded transcript.
     */
    public static clipPlannerCreate<ThrowOnError extends boolean = true>(options: Options<ClipPlannerCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ClipPlannerCreateResponse, ClipPlannerCreateError, ThrowOnError>({
            ...options,
            url: '/api/clip-planner/'
        });
    }
    
    public static colorFilterList<ThrowOnError extends boolean = true>(options?: Options<ColorFilterListData, ThrowOnError>) {
        return (options?.client ?? client).get<ColorFilterListResponse, ColorFilterListError, ThrowOnError>({
            ...options,
            url: '/api/color-filter/'
        });
    }
    
    /**
     * Save a conversation to the database.
     * Called explicitly by frontend after LLM interactions.
     */
    public static saveConversation<ThrowOnError extends boolean = true>(options: Options<SaveConversationData, ThrowOnError>) {
        return (options?.client ?? client).post<SaveConversationResponse, SaveConversationError, ThrowOnError>({
            ...options,
            url: '/api/conversations/'
        });
    }
    
    /**
     * Get conversation details by ID.
     * Staff-only access for debugging.
     */
    public static getConversation<ThrowOnError extends boolean = true>(options: Options<GetConversationData, ThrowOnError>) {
        return (options?.client ?? client).get<GetConversationResponse, GetConversationError, ThrowOnError>({
            ...options,
            url: '/api/conversations/{id}/'
        });
    }
    
    public static copyMediaAssetsCreate<ThrowOnError extends boolean = true>(options: Options<CopyMediaAssetsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<CopyMediaAssetsCreateResponse, CopyMediaAssetsCreateError, ThrowOnError>({
            ...options,
            url: '/api/copy-media-assets/'
        });
    }
    
    /**
     * Viewset for customer specific blueprints
     *
     * retrieve - can get customer-specific blueprints if the user has permission
     * list - get customer-specific blueprints if the user has permission
     * create_from_similar - create a new blueprint starting from a video and finding similar videos
     * create/delete/partial_update - customer specific blueprints if the user has permission
     * update - not implemented
     */
    public static customBlueprintsList<ThrowOnError extends boolean = true>(options?: Options<CustomBlueprintsListData, ThrowOnError>) {
        return (options?.client ?? client).get<CustomBlueprintsListResponse, CustomBlueprintsListError, ThrowOnError>({
            ...options,
            url: '/api/custom-blueprints/'
        });
    }
    
    /**
     * Viewset for customer specific blueprints
     *
     * retrieve - can get customer-specific blueprints if the user has permission
     * list - get customer-specific blueprints if the user has permission
     * create_from_similar - create a new blueprint starting from a video and finding similar videos
     * create/delete/partial_update - customer specific blueprints if the user has permission
     * update - not implemented
     */
    public static customBlueprintsCreate<ThrowOnError extends boolean = true>(options: Options<CustomBlueprintsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<CustomBlueprintsCreateResponse, CustomBlueprintsCreateError, ThrowOnError>({
            ...options,
            url: '/api/custom-blueprints/'
        });
    }
    
    /**
     * Viewset for customer specific blueprints
     *
     * retrieve - can get customer-specific blueprints if the user has permission
     * list - get customer-specific blueprints if the user has permission
     * create_from_similar - create a new blueprint starting from a video and finding similar videos
     * create/delete/partial_update - customer specific blueprints if the user has permission
     * update - not implemented
     */
    public static customBlueprintsRetrieve<ThrowOnError extends boolean = true>(options: Options<CustomBlueprintsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<CustomBlueprintsRetrieveResponse, CustomBlueprintsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/custom-blueprints/{id}/'
        });
    }
    
    /**
     * Viewset for customer specific blueprints
     *
     * retrieve - can get customer-specific blueprints if the user has permission
     * list - get customer-specific blueprints if the user has permission
     * create_from_similar - create a new blueprint starting from a video and finding similar videos
     * create/delete/partial_update - customer specific blueprints if the user has permission
     * update - not implemented
     */
    public static customBlueprintsPartialUpdate<ThrowOnError extends boolean = true>(options: Options<CustomBlueprintsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<CustomBlueprintsPartialUpdateResponse, CustomBlueprintsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/custom-blueprints/{id}/'
        });
    }
    
    /**
     * Archive the blueprint instead of permanently deleting it
     */
    public static customBlueprintsDestroy<ThrowOnError extends boolean = true>(options: Options<CustomBlueprintsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<CustomBlueprintsDestroyResponse, CustomBlueprintsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/custom-blueprints/{id}/'
        });
    }
    
    /**
     * Viewset for customer specific blueprints
     *
     * retrieve - can get customer-specific blueprints if the user has permission
     * list - get customer-specific blueprints if the user has permission
     * create_from_similar - create a new blueprint starting from a video and finding similar videos
     * create/delete/partial_update - customer specific blueprints if the user has permission
     * update - not implemented
     */
    public static customBlueprintsDuplicateCreate<ThrowOnError extends boolean = true>(options: Options<CustomBlueprintsDuplicateCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<CustomBlueprintsDuplicateCreateResponse, CustomBlueprintsDuplicateCreateError, ThrowOnError>({
            ...options,
            url: '/api/custom-blueprints/{id}/duplicate/'
        });
    }
    
    /**
     * Viewset for customer specific blueprints
     *
     * retrieve - can get customer-specific blueprints if the user has permission
     * list - get customer-specific blueprints if the user has permission
     * create_from_similar - create a new blueprint starting from a video and finding similar videos
     * create/delete/partial_update - customer specific blueprints if the user has permission
     * update - not implemented
     */
    public static customBlueprintsCreateFromSimilarCreate<ThrowOnError extends boolean = true>(options: Options<CustomBlueprintsCreateFromSimilarCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<CustomBlueprintsCreateFromSimilarCreateResponse, CustomBlueprintsCreateFromSimilarCreateError, ThrowOnError>({
            ...options,
            url: '/api/custom-blueprints/create_from_similar/'
        });
    }
    
    /**
     * Viewset for customer specific blueprints
     *
     * retrieve - can get customer-specific blueprints if the user has permission
     * list - get customer-specific blueprints if the user has permission
     * create_from_similar - create a new blueprint starting from a video and finding similar videos
     * create/delete/partial_update - customer specific blueprints if the user has permission
     * update - not implemented
     */
    public static customBlueprintsCreateFromSuggestedBlueprintCreate<ThrowOnError extends boolean = true>(options: Options<CustomBlueprintsCreateFromSuggestedBlueprintCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<CustomBlueprintsCreateFromSuggestedBlueprintCreateResponse, CustomBlueprintsCreateFromSuggestedBlueprintCreateError, ThrowOnError>({
            ...options,
            url: '/api/custom-blueprints/create_from_suggested_blueprint/'
        });
    }
    
    /**
     * This endpoint is used to search for media in a DAM provider.
     */
    public static damSearchCreate<ThrowOnError extends boolean = true>(options: Options<DamSearchCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<DamSearchCreateResponse, DamSearchCreateError, ThrowOnError>({
            ...options,
            url: '/api/dam-search/'
        });
    }
    
    /**
     * This endpoint is used to retrieve and update data metadata for a video.
     */
    public static datasetMetadataRetrieve<ThrowOnError extends boolean = true>(options: Options<DatasetMetadataRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<DatasetMetadataRetrieveResponse, DatasetMetadataRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/dataset-metadata/{id}/'
        });
    }
    
    /**
     * This endpoint is used to retrieve and update data metadata for a video.
     */
    public static datasetMetadataUpdate<ThrowOnError extends boolean = true>(options: Options<DatasetMetadataUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<DatasetMetadataUpdateResponse, DatasetMetadataUpdateError, ThrowOnError>({
            ...options,
            url: '/api/dataset-metadata/{id}/'
        });
    }
    
    /**
     * This endpoint is used to retrieve and update data metadata for a video.
     */
    public static datasetMetadataPartialUpdate<ThrowOnError extends boolean = true>(options: Options<DatasetMetadataPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<DatasetMetadataPartialUpdateResponse, DatasetMetadataPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/dataset-metadata/{id}/'
        });
    }
    
    public static documentResetUpdate<ThrowOnError extends boolean = true>(options: Options<DocumentResetUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<DocumentResetUpdateResponse, DocumentResetUpdateError, ThrowOnError>({
            ...options,
            url: '/api/document/reset/'
        });
    }
    
    /**
     * Creates a standalone Document (no Video required) and triggers text extraction.
     */
    public static documentsCreate<ThrowOnError extends boolean = true>(options: Options<DocumentsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<DocumentsCreateResponse, DocumentsCreateError, ThrowOnError>({
            ...options,
            url: '/api/documents/'
        });
    }
    
    public static documentsImagesList<ThrowOnError extends boolean = true>(options: Options<DocumentsImagesListData, ThrowOnError>) {
        return (options?.client ?? client).get<DocumentsImagesListResponse, DocumentsImagesListError, ThrowOnError>({
            ...options,
            url: '/api/documents/{documents_pk}/images/'
        });
    }
    
    public static documentsImagesDestroy<ThrowOnError extends boolean = true>(options: Options<DocumentsImagesDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<DocumentsImagesDestroyResponse, DocumentsImagesDestroyError, ThrowOnError>({
            ...options,
            url: '/api/documents/{documents_pk}/images/{id}/'
        });
    }
    
    public static documentsImagesDeleteAllDestroy<ThrowOnError extends boolean = true>(options: Options<DocumentsImagesDeleteAllDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<DocumentsImagesDeleteAllDestroyResponse, DocumentsImagesDeleteAllDestroyError, ThrowOnError>({
            ...options,
            url: '/api/documents/{documents_pk}/images/delete_all/'
        });
    }
    
    /**
     * Triggers the task to create Document
     */
    public static documentsUpdate<ThrowOnError extends boolean = true>(options: Options<DocumentsUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<DocumentsUpdateResponse, DocumentsUpdateError, ThrowOnError>({
            ...options,
            url: '/api/documents/{id}/'
        });
    }
    
    public static documentsPartialUpdate<ThrowOnError extends boolean = true>(options: Options<DocumentsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<DocumentsPartialUpdateResponse, DocumentsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/documents/{id}/'
        });
    }
    
    /**
     * The endpoint to edit AI voiceover audio file and transcript. This is used for several features:
     *
     * - Editing the transcript of an AI Voiceover (obviously!)
     * - Swapping the voice that an AI Voiceover uses
     * - Re-generating the AI Voice for a region of the transcript
     * - Translating an AI Voiceover scenegroup to a new language
     */
    public static editVoiceoverUpdate<ThrowOnError extends boolean = true>(options: Options<EditVoiceoverUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<EditVoiceoverUpdateResponse, EditVoiceoverUpdateError, ThrowOnError>({
            ...options,
            url: '/api/edit-voiceover/'
        });
    }
    
    /**
     * Asynchronously check if email exists in our DB
     */
    public static emailExistsCreate<ThrowOnError extends boolean = true>(options: Options<EmailExistsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<EmailExistsCreateResponse, EmailExistsCreateError, ThrowOnError>({
            ...options,
            url: '/api/email-exists/'
        });
    }
    
    public static faceDetectionCreate<ThrowOnError extends boolean = true>(options: Options<FaceDetectionCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<FaceDetectionCreateResponse, FaceDetectionCreateError, ThrowOnError>({
            ...options,
            url: '/api/face-detection/'
        });
    }
    
    /**
     * Retrieves all favorites so the frontend can star them in library tabs.
     */
    public static favoritesListMarkedFavoritesList<ThrowOnError extends boolean = true>(options?: Options<FavoritesListMarkedFavoritesListData, ThrowOnError>) {
        return (options?.client ?? client).get<FavoritesListMarkedFavoritesListResponse, FavoritesListMarkedFavoritesListError, ThrowOnError>({
            ...options,
            url: '/api/favorites/list_marked_favorites/'
        });
    }
    
    /**
     * Adds an asset to favorites indexes
     */
    public static favoritesMarkFavoriteCreate<ThrowOnError extends boolean = true>(options: Options<FavoritesMarkFavoriteCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<FavoritesMarkFavoriteCreateResponse, FavoritesMarkFavoriteCreateError, ThrowOnError>({
            ...options,
            url: '/api/favorites/mark_favorite/'
        });
    }
    
    /**
     * Removes an asset from favorites indexes
     */
    public static favoritesUnmarkFavoriteDestroy<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).delete<FavoritesUnmarkFavoriteDestroyResponse, FavoritesUnmarkFavoriteDestroyError, ThrowOnError>({
            ...options,
            url: '/api/favorites/unmark_favorite/'
        });
    }
    
    /**
     * Submit feedback for beta features (chat, sketch, etc).
     */
    public static feedbackBetaCreate<ThrowOnError extends boolean = true>(options: Options<FeedbackBetaCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<FeedbackBetaCreateResponse, FeedbackBetaCreateError, ThrowOnError>({
            ...options,
            url: '/api/feedback/beta/'
        });
    }
    
    public static fetchArticleImageRetrieve<ThrowOnError extends boolean = true>(options?: Options<FetchArticleImageRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<FetchArticleImageRetrieveResponse, FetchArticleImageRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/fetch_article_image/'
        });
    }
    
    /**
     * This is a viewset for feature flags offering the following two custom actions:
     * - "enroll" endpoint which will opt-in the user to the specified feature flag
     * - if in DEBUG mode and the feature flag doesn't exist, will create it first
     * - "withdraw" endpoint which will opt-out the user from the specified feature flag
     */
    public static flagEnrollRetrieve<ThrowOnError extends boolean = true>(options: Options<FlagEnrollRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<FlagEnrollRetrieveResponse, FlagEnrollRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/flag/{id}/enroll/'
        });
    }
    
    /**
     * This is a viewset for feature flags offering the following two custom actions:
     * - "enroll" endpoint which will opt-in the user to the specified feature flag
     * - if in DEBUG mode and the feature flag doesn't exist, will create it first
     * - "withdraw" endpoint which will opt-out the user from the specified feature flag
     */
    public static flagWithdrawRetrieve<ThrowOnError extends boolean = true>(options: Options<FlagWithdrawRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<FlagWithdrawRetrieveResponse, FlagWithdrawRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/flag/{id}/withdraw/'
        });
    }
    
    /**
     * List all active feature flags with user's enrollment status (staff only)
     */
    public static flagListAllList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<FlagListAllListResponse, FlagListAllListError, ThrowOnError>({
            ...options,
            url: '/api/flag/list_all/'
        });
    }
    
    public static fontAssetsList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<FontAssetsListResponse, FontAssetsListError, ThrowOnError>({
            ...options,
            url: '/api/font-assets/'
        });
    }
    
    public static fontAssetsDestroy<ThrowOnError extends boolean = true>(options: Options<FontAssetsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<FontAssetsDestroyResponse, FontAssetsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/font-assets/{id}/'
        });
    }
    
    /**
     * This endpoint is used to generate media candidates for a video in the dataset.
     */
    public static generateMediaCandidatesCreate<ThrowOnError extends boolean = true>(options: Options<GenerateMediaCandidatesCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GenerateMediaCandidatesCreateResponse, GenerateMediaCandidatesCreateError, ThrowOnError>({
            ...options,
            url: '/api/generate-media-candidates/{video_id}/'
        });
    }
    
    /**
     * This endpoint generates a script from a provided document (summarizing the document into a script).
     */
    public static generateScriptCreate<ThrowOnError extends boolean = true>(options: Options<GenerateScriptCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GenerateScriptCreateResponse, GenerateScriptCreateError, ThrowOnError>({
            ...options,
            url: '/api/generate-script/'
        });
    }
    
    /**
     * This endpoint generates a script from a provided user prompt, enabling creating
     * a script from basically nothing or a few bullet points.
     */
    public static generateScriptFromPromptCreate<ThrowOnError extends boolean = true>(options: Options<GenerateScriptFromPromptCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GenerateScriptFromPromptCreateResponse, GenerateScriptFromPromptCreateError, ThrowOnError>({
            ...options,
            url: '/api/generate-script-from-prompt/'
        });
    }
    
    /**
     * This endpoint generates a video recommendation, a series of scenes.
     */
    public static generateVideoRecommendationCreate<ThrowOnError extends boolean = true>(options: Options<GenerateVideoRecommendationCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GenerateVideoRecommendationCreateResponse, GenerateVideoRecommendationCreateError, ThrowOnError>({
            ...options,
            url: '/api/generate-video-recommendation/'
        });
    }
    
    /**
     * This endpoint generates videos for a list of VideoPlans. This is used when showing a list of recommended videos
     * for the user to pick from.
     */
    public static generateVideosForVideoPlansCreate<ThrowOnError extends boolean = true>(options: Options<GenerateVideosForVideoPlansCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GenerateVideosForVideoPlansCreateResponse, GenerateVideosForVideoPlansCreateError, ThrowOnError>({
            ...options,
            url: '/api/generate-videos-for-video-plans/'
        });
    }
    
    public static getLanguageInfoForTextCreate<ThrowOnError extends boolean = true>(options: Options<GetLanguageInfoForTextCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GetLanguageInfoForTextCreateResponse, GetLanguageInfoForTextCreateError, ThrowOnError>({
            ...options,
            url: '/api/get-language-info-for-text'
        });
    }
    
    public static imageGenerationCreate<ThrowOnError extends boolean = true>(options: Options<ImageGenerationCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ImageGenerationCreateResponse, ImageGenerationCreateError, ThrowOnError>({
            ...options,
            url: '/api/image-generation/'
        });
    }
    
    /**
     * Generate inspiration ideas for the user based on their content history
     */
    public static inspirationCreate<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).post<InspirationCreateResponse, InspirationCreateError, ThrowOnError>({
            ...options,
            url: '/api/inspiration/'
        });
    }
    
    public static isAuthenticatedRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<IsAuthenticatedRetrieveResponse, IsAuthenticatedRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/is-authenticated/'
        });
    }
    
    /**
     * Logs media agent results for analysis of feature flag experiments.
     * Logs are output as JSON to the media_agent_results logger.
     */
    public static logMediaAgentResultsCreate<ThrowOnError extends boolean = true>(options: Options<LogMediaAgentResultsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<LogMediaAgentResultsCreateResponse, LogMediaAgentResultsCreateError, ThrowOnError>({
            ...options,
            url: '/api/log-media-agent-results/'
        });
    }
    
    public static longestSupportedDurationTargetsCreate<ThrowOnError extends boolean = true>(options: Options<LongestSupportedDurationTargetsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<LongestSupportedDurationTargetsCreateResponse, LongestSupportedDurationTargetsCreateError, ThrowOnError>({
            ...options,
            url: '/api/longest-supported-duration-targets/'
        });
    }
    
    /**
     * A ViewSet for retrieving the text representation of a media asset by UUID.
     */
    public static mediaAssetTextRepresentationRetrieve<ThrowOnError extends boolean = true>(options: Options<MediaAssetTextRepresentationRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<MediaAssetTextRepresentationRetrieveResponse, MediaAssetTextRepresentationRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/media-asset-text-representation/{media_asset_uuid}/'
        });
    }
    
    public static mediaFoldersList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<MediaFoldersListResponse, MediaFoldersListError, ThrowOnError>({
            ...options,
            url: '/api/media-folders/'
        });
    }
    
    public static mediaFoldersCreate<ThrowOnError extends boolean = true>(options?: Options<MediaFoldersCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<MediaFoldersCreateResponse, MediaFoldersCreateError, ThrowOnError>({
            ...options,
            url: '/api/media-folders/'
        });
    }
    
    public static mediaFoldersRetrieve<ThrowOnError extends boolean = true>(options: Options<MediaFoldersRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<MediaFoldersRetrieveResponse, MediaFoldersRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/media-folders/{id}/'
        });
    }
    
    public static mediaFoldersPartialUpdate<ThrowOnError extends boolean = true>(options: Options<MediaFoldersPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<MediaFoldersPartialUpdateResponse, MediaFoldersPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/media-folders/{id}/'
        });
    }
    
    public static mediaFoldersDestroy<ThrowOnError extends boolean = true>(options: Options<MediaFoldersDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<MediaFoldersDestroyResponse, MediaFoldersDestroyError, ThrowOnError>({
            ...options,
            url: '/api/media-folders/{id}/'
        });
    }
    
    public static mediaSearchCreate<ThrowOnError extends boolean = true>(options?: Options<MediaSearchCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<MediaSearchCreateResponse, MediaSearchCreateError, ThrowOnError>({
            ...options,
            url: '/api/media-search/'
        });
    }
    
    public static mergeTeamsCreate<ThrowOnError extends boolean = true>(options: Options<MergeTeamsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<MergeTeamsCreateResponse, MergeTeamsCreateError, ThrowOnError>({
            ...options,
            url: '/api/merge-teams/'
        });
    }
    
    /**
     * Proxy some frontend events to be server-fired. This ensures they're always sent.
     */
    public static mixyCreate<ThrowOnError extends boolean = true>(options: Options<MixyCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<MixyCreateResponse, MixyCreateError, ThrowOnError>({
            ...options,
            url: '/api/mixy/'
        });
    }
    
    public static musicRecommendationCreate<ThrowOnError extends boolean = true>(options: Options<MusicRecommendationCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<MusicRecommendationCreateResponse, MusicRecommendationCreateError, ThrowOnError>({
            ...options,
            url: '/api/music_recommendation/'
        });
    }
    
    public static muteAudioCreate<ThrowOnError extends boolean = true>(options: Options<MuteAudioCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<MuteAudioCreateResponse, MuteAudioCreateError, ThrowOnError>({
            ...options,
            url: '/api/mute-audio/'
        });
    }
    
    public static nameSuggestionCreate<ThrowOnError extends boolean = true>(options: Options<NameSuggestionCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<NameSuggestionCreateResponse, NameSuggestionCreateError, ThrowOnError>({
            ...options,
            url: '/api/name-suggestion/'
        });
    }
    
    /**
     * In-app notifications to keep track of things like rendering success/fail, comments, and approvals
     */
    public static notificationsList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<NotificationsListResponse, NotificationsListError, ThrowOnError>({
            ...options,
            url: '/api/notifications/'
        });
    }
    
    /**
     * In-app notifications to keep track of things like rendering success/fail, comments, and approvals
     */
    public static notificationsMarkAsReadPartialUpdate<ThrowOnError extends boolean = true>(options: Options<NotificationsMarkAsReadPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<NotificationsMarkAsReadPartialUpdateResponse, NotificationsMarkAsReadPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/notifications/{id}/mark_as_read/'
        });
    }
    
    /**
     * In-app notifications to keep track of things like rendering success/fail, comments, and approvals
     */
    public static notificationsMarkAllAsReadPartialUpdate<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).patch<NotificationsMarkAllAsReadPartialUpdateResponse, NotificationsMarkAllAsReadPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/notifications/mark_all_as_read/'
        });
    }
    
    /**
     * In-app notifications to keep track of things like rendering success/fail, comments, and approvals
     */
    public static notificationsNumUnreadRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<NotificationsNumUnreadRetrieveResponse, NotificationsNumUnreadRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/notifications/num_unread/'
        });
    }
    
    /**
     * Handles the submission of the forgot-password form.
     */
    public static passwordForgotCreate<ThrowOnError extends boolean = true>(options: Options<PasswordForgotCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<PasswordForgotCreateResponse, PasswordForgotCreateError, ThrowOnError>({
            ...options,
            url: '/api/password/forgot/'
        });
    }
    
    /**
     * Handles password resets from the reset password form.
     */
    public static passwordResetCreate<ThrowOnError extends boolean = true>(options: Options<PasswordResetCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<PasswordResetCreateResponse, PasswordResetCreateError, ThrowOnError>({
            ...options,
            url: '/api/password/reset/'
        });
    }
    
    /**
     * Prefetches media candidates for a given script & media settings for faster video generation.
     */
    public static prefetchMediaCandidatesCreate<ThrowOnError extends boolean = true>(options: Options<PrefetchMediaCandidatesCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<PrefetchMediaCandidatesCreateResponse, PrefetchMediaCandidatesCreateError, ThrowOnError>({
            ...options,
            url: '/api/prefetch-media-candidates/'
        });
    }
    
    public static premiumMediaCreditCheckCreate<ThrowOnError extends boolean = true>(options: Options<PremiumMediaCreditCheckCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<PremiumMediaCreditCheckCreateResponse, PremiumMediaCreditCheckCreateError, ThrowOnError>({
            ...options,
            url: '/api/premium-media-credit-check/'
        });
    }
    
    /**
     * params:
     * reason: The selected reason for cancellation (optional)
     * other_reason: If other reason the user provided reason (optional)
     * feedback: General feedback for improvement (optional)
     */
    public static pricingCancellationFeedbackCreate<ThrowOnError extends boolean = true>(options?: Options<PricingCancellationFeedbackCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<PricingCancellationFeedbackCreateResponse, PricingCancellationFeedbackCreateError, ThrowOnError>({
            ...options,
            url: '/api/pricing/cancellation_feedback/'
        });
    }
    
    public static pricingCreditCardDetailsRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<PricingCreditCardDetailsRetrieveResponse, PricingCreditCardDetailsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/pricing/credit-card-details/'
        });
    }
    
    public static pricingCurrentPlanNameRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<PricingCurrentPlanNameRetrieveResponse, PricingCurrentPlanNameRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/pricing/current-plan-name/'
        });
    }
    
    /**
     * This api is used for changing payment method
     */
    public static pricingPaymentMethodCheckoutUpdate<ThrowOnError extends boolean = true>(options?: Options<PricingPaymentMethodCheckoutUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<PricingPaymentMethodCheckoutUpdateResponse, PricingPaymentMethodCheckoutUpdateError, ThrowOnError>({
            ...options,
            url: '/api/pricing/payment-method-checkout/'
        });
    }
    
    public static pricingPaymentMethodStatusRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<PricingPaymentMethodStatusRetrieveResponse, PricingPaymentMethodStatusRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/pricing/payment_method_status/'
        });
    }
    
    public static pricingPlansRetrieve<ThrowOnError extends boolean = true>(options?: Options<PricingPlansRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<PricingPlansRetrieveResponse, PricingPlansRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/pricing/plans/'
        });
    }
    
    public static pricingPremiumMediaRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<PricingPremiumMediaRetrieveResponse, PricingPremiumMediaRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/pricing/premium-media/'
        });
    }
    
    /**
     * This updates a team's subscription to no longer cancel at the end of the billing cycle
     */
    public static pricingRenewSubscriptionCreate<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).post<PricingRenewSubscriptionCreateResponse, PricingRenewSubscriptionCreateError, ThrowOnError>({
            ...options,
            url: '/api/pricing/renew_subscription/'
        });
    }
    
    public static pricingSubscriptionRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<PricingSubscriptionRetrieveResponse, PricingSubscriptionRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/pricing/subscription/'
        });
    }
    
    /**
     * Initiates a checkout session with stripe, used for new customers or customers
     * without a valid payment method.
     */
    public static pricingSubscriptionCreate<ThrowOnError extends boolean = true>(options: Options<PricingSubscriptionCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<PricingSubscriptionCreateResponse, PricingSubscriptionCreateError, ThrowOnError>({
            ...options,
            url: '/api/pricing/subscription/'
        });
    }
    
    /**
     * Used to update a subscription for an existing customer.
     */
    public static pricingSubscriptionPartialUpdate<ThrowOnError extends boolean = true>(options?: Options<PricingSubscriptionPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<PricingSubscriptionPartialUpdateResponse, PricingSubscriptionPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/pricing/subscription/'
        });
    }
    
    /**
     * Pause a subscription for a specified duration or indefinitely.
     */
    public static pricingSubscriptionPauseCreate<ThrowOnError extends boolean = true>(options?: Options<PricingSubscriptionPauseCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<PricingSubscriptionPauseCreateResponse, PricingSubscriptionPauseCreateError, ThrowOnError>({
            ...options,
            url: '/api/pricing/subscription/pause/'
        });
    }
    
    /**
     * Resume a paused subscription immediately.
     */
    public static pricingSubscriptionResumeCreate<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).post<PricingSubscriptionResumeCreateResponse, PricingSubscriptionResumeCreateError, ThrowOnError>({
            ...options,
            url: '/api/pricing/subscription/resume/'
        });
    }
    
    public static projectsList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<ProjectsListResponse, ProjectsListError, ThrowOnError>({
            ...options,
            url: '/api/projects/'
        });
    }
    
    public static projectsCreate<ThrowOnError extends boolean = true>(options?: Options<ProjectsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ProjectsCreateResponse, ProjectsCreateError, ThrowOnError>({
            ...options,
            url: '/api/projects/'
        });
    }
    
    public static projectsRetrieve<ThrowOnError extends boolean = true>(options: Options<ProjectsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<ProjectsRetrieveResponse, ProjectsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/projects/{id}/'
        });
    }
    
    public static projectsPartialUpdate<ThrowOnError extends boolean = true>(options: Options<ProjectsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<ProjectsPartialUpdateResponse, ProjectsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/projects/{id}/'
        });
    }
    
    public static projectsDestroy<ThrowOnError extends boolean = true>(options: Options<ProjectsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<ProjectsDestroyResponse, ProjectsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/projects/{id}/'
        });
    }
    
    public static pronunciationList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<PronunciationListResponse, PronunciationListError, ThrowOnError>({
            ...options,
            url: '/api/pronunciation/'
        });
    }
    
    /**
     * Upsert Pronunciation object to team's Pronunciation dictionary
     */
    public static pronunciationUpsert<ThrowOnError extends boolean = true>(options: Options<PronunciationUpsertData, ThrowOnError>) {
        return (options?.client ?? client).put<PronunciationUpsertResponse, PronunciationUpsertError, ThrowOnError>({
            ...options,
            url: '/api/pronunciation/'
        });
    }
    
    public static pronunciationDestroy<ThrowOnError extends boolean = true>(options: Options<PronunciationDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<PronunciationDestroyResponse, PronunciationDestroyError, ThrowOnError>({
            ...options,
            url: '/api/pronunciation/{id}/'
        });
    }
    
    /**
     * Viewset for public blueprints
     *
     * retrieve - can only get public blueprints
     * list - can only get public blueprints
     * create/delete/partial_update - only if the user is staff
     * update - not implemented
     */
    public static publicBlueprintsList<ThrowOnError extends boolean = true>(options?: Options<PublicBlueprintsListData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicBlueprintsListResponse, PublicBlueprintsListError, ThrowOnError>({
            ...options,
            url: '/api/public-blueprints/'
        });
    }
    
    /**
     * Viewset for public blueprints
     *
     * retrieve - can only get public blueprints
     * list - can only get public blueprints
     * create/delete/partial_update - only if the user is staff
     * update - not implemented
     */
    public static publicBlueprintsCreate<ThrowOnError extends boolean = true>(options: Options<PublicBlueprintsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<PublicBlueprintsCreateResponse, PublicBlueprintsCreateError, ThrowOnError>({
            ...options,
            url: '/api/public-blueprints/'
        });
    }
    
    /**
     * Viewset for public blueprints
     *
     * retrieve - can only get public blueprints
     * list - can only get public blueprints
     * create/delete/partial_update - only if the user is staff
     * update - not implemented
     */
    public static publicBlueprintsRetrieve<ThrowOnError extends boolean = true>(options: Options<PublicBlueprintsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicBlueprintsRetrieveResponse, PublicBlueprintsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/public-blueprints/{id}/'
        });
    }
    
    /**
     * Viewset for public blueprints
     *
     * retrieve - can only get public blueprints
     * list - can only get public blueprints
     * create/delete/partial_update - only if the user is staff
     * update - not implemented
     */
    public static publicBlueprintsPartialUpdate<ThrowOnError extends boolean = true>(options: Options<PublicBlueprintsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<PublicBlueprintsPartialUpdateResponse, PublicBlueprintsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/public-blueprints/{id}/'
        });
    }
    
    /**
     * Viewset for public blueprints
     *
     * retrieve - can only get public blueprints
     * list - can only get public blueprints
     * create/delete/partial_update - only if the user is staff
     * update - not implemented
     */
    public static publicBlueprintsDestroy<ThrowOnError extends boolean = true>(options: Options<PublicBlueprintsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<PublicBlueprintsDestroyResponse, PublicBlueprintsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/public-blueprints/{id}/'
        });
    }
    
    /**
     * A simple endpoint that is exposed publicly so that anyone can view the
     * video (if the link is shared by email or something). This endpoint
     * should not return any personally identifiable information!
     */
    public static publicVideoRetrieve<ThrowOnError extends boolean = true>(options: Options<PublicVideoRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicVideoRetrieveResponse, PublicVideoRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/public-video/{slug}/'
        });
    }
    
    /**
     * Video has errored if a video has published which started rendering
     * 30+ mins after it
     * If we have >= 50 videos in the queue, report 'rendering' as we likely
     * have an issue
     */
    public static queueEstimatedRenderDurationRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<QueueEstimatedRenderDurationRetrieveResponse, QueueEstimatedRenderDurationRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/queue/estimated_render_duration/'
        });
    }
    
    /**
     * Returns relevant rendering details for a video
     */
    public static queueVideoRenderDetailsRetrieve<ThrowOnError extends boolean = true>(options: Options<QueueVideoRenderDetailsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<QueueVideoRenderDetailsRetrieveResponse, QueueVideoRenderDetailsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/queue/video_render_details/{video_id}/'
        });
    }
    
    /**
     * Returns last 3 templates used to publish videos.
     */
    public static recentlyUsedTemplatesList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<RecentlyUsedTemplatesListResponse, RecentlyUsedTemplatesListError, ThrowOnError>({
            ...options,
            url: '/api/recently_used_templates/'
        });
    }
    
    public static regenerateTranscriptForAssetCreate<ThrowOnError extends boolean = true>(options: Options<RegenerateTranscriptForAssetCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<RegenerateTranscriptForAssetCreateResponse, RegenerateTranscriptForAssetCreateError, ThrowOnError>({
            ...options,
            url: '/api/regenerate-transcript-for-asset/'
        });
    }
    
    public static regenerateMfaBackupKeysCreate<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).post<RegenerateMfaBackupKeysCreateResponse, RegenerateMfaBackupKeysCreateError, ThrowOnError>({
            ...options,
            url: '/api/regenerate_mfa_backup_keys/'
        });
    }
    
    public static resolveCommentsCreate<ThrowOnError extends boolean = true>(options: Options<ResolveCommentsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ResolveCommentsCreateResponse, ResolveCommentsCreateError, ThrowOnError>({
            ...options,
            url: '/api/resolve_comments/'
        });
    }
    
    /**
     * GET: Get the list of rss feeds the user is subscribed to w/ top entries
     * POST: Create new RSS feed
     */
    public static rssFeedsList<ThrowOnError extends boolean = true>(options?: Options<RssFeedsListData, ThrowOnError>) {
        return (options?.client ?? client).get<RssFeedsListResponse, RssFeedsListError, ThrowOnError>({
            ...options,
            url: '/api/rss-feeds/'
        });
    }
    
    /**
     * The url must have a query param that is set equal to a valid:
     * ?url=domain.com
     */
    public static rssFeedsCreate<ThrowOnError extends boolean = true>(options: Options<RssFeedsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<RssFeedsCreateResponse, RssFeedsCreateError, ThrowOnError>({
            ...options,
            url: '/api/rss-feeds/'
        });
    }
    
    /**
     * Update the RSS feed
     */
    public static rssFeedsUpdate<ThrowOnError extends boolean = true>(options: Options<RssFeedsUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<RssFeedsUpdateResponse, RssFeedsUpdateError, ThrowOnError>({
            ...options,
            url: '/api/rss-feeds/{feed_id}/'
        });
    }
    
    /**
     * Get the list of rss feed entries for a given rss feed
     */
    public static rssFeedsEntriesList<ThrowOnError extends boolean = true>(options: Options<RssFeedsEntriesListData, ThrowOnError>) {
        return (options?.client ?? client).get<RssFeedsEntriesListResponse, RssFeedsEntriesListError, ThrowOnError>({
            ...options,
            url: '/api/rss-feeds/{feed_id}/entries/'
        });
    }
    
    /**
     * This endpoint saves video data (luminary state) to GCS bucket and returns a UUID and URL
     * for later retrieval. Used for logging video states during agent conversations.
     */
    public static saveVideoDataSnapshotCreate<ThrowOnError extends boolean = true>(options: Options<SaveVideoDataSnapshotCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SaveVideoDataSnapshotCreateResponse, SaveVideoDataSnapshotCreateError, ThrowOnError>({
            ...options,
            url: '/api/save-video-data-snapshot/'
        });
    }
    
    /**
     * Fetches the recommended scene attributes to optimize content on a scene. Returns information
     * for the ideal crop, brightness, scene design, background animation, etc.
     */
    public static sceneAttributesList<ThrowOnError extends boolean = true>(options: Options<SceneAttributesListData, ThrowOnError>) {
        return (options?.client ?? client).get<SceneAttributesListResponse, SceneAttributesListError, ThrowOnError>({
            ...options,
            url: '/api/scene-attributes/'
        });
    }
    
    public static sceneDesignsList<ThrowOnError extends boolean = true>(options: Options<SceneDesignsListData, ThrowOnError>) {
        return (options?.client ?? client).get<SceneDesignsListResponse, SceneDesignsListError, ThrowOnError>({
            ...options,
            url: '/api/scene-designs/'
        });
    }
    
    public static sceneDesignsCreate<ThrowOnError extends boolean = true>(options: Options<SceneDesignsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SceneDesignsCreateResponse, SceneDesignsCreateError, ThrowOnError>({
            ...options,
            url: '/api/scene-designs/'
        });
    }
    
    public static sceneDesignsRetrieve<ThrowOnError extends boolean = true>(options: Options<SceneDesignsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<SceneDesignsRetrieveResponse, SceneDesignsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/scene-designs/{id}/'
        });
    }
    
    public static sceneDesignsUpdate<ThrowOnError extends boolean = true>(options: Options<SceneDesignsUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<SceneDesignsUpdateResponse, SceneDesignsUpdateError, ThrowOnError>({
            ...options,
            url: '/api/scene-designs/{id}/'
        });
    }
    
    public static sceneDesignsPartialUpdate<ThrowOnError extends boolean = true>(options: Options<SceneDesignsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<SceneDesignsPartialUpdateResponse, SceneDesignsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/scene-designs/{id}/'
        });
    }
    
    public static sceneDesignsDestroy<ThrowOnError extends boolean = true>(options: Options<SceneDesignsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<SceneDesignsDestroyResponse, SceneDesignsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/scene-designs/{id}/'
        });
    }
    
    public static sceneDesignsBulkUpdateUpdate<ThrowOnError extends boolean = true>(options: Options<SceneDesignsBulkUpdateUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<SceneDesignsBulkUpdateUpdateResponse, SceneDesignsBulkUpdateUpdateError, ThrowOnError>({
            ...options,
            url: '/api/scene-designs/bulk_update/'
        });
    }
    
    public static sceneDesignsIdsPerTemplateList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<SceneDesignsIdsPerTemplateListResponse, SceneDesignsIdsPerTemplateListError, ThrowOnError>({
            ...options,
            url: '/api/scene-designs/ids_per_template/'
        });
    }
    
    public static sceneDesignsTemplateAnnotationsRetrieve<ThrowOnError extends boolean = true>(options: Options<SceneDesignsTemplateAnnotationsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<SceneDesignsTemplateAnnotationsRetrieveResponse, SceneDesignsTemplateAnnotationsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/scene-designs/template_annotations/'
        });
    }
    
    /**
     * We currently support two versions here:
     * 1 = Script Composer (no duration targeting)
     * 2 = Script Composer (with duration targeting)
     */
    public static scriptOptionsCreate<ThrowOnError extends boolean = true>(options: Options<ScriptOptionsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ScriptOptionsCreateResponse, ScriptOptionsCreateError, ThrowOnError>({
            ...options,
            url: '/api/script-options/'
        });
    }
    
    /**
     * Endpoint to send email verification email. The user is not authenticated so user_id must be provided to look up the user.
     */
    public static sendEmailVerificationCreate<ThrowOnError extends boolean = true>(options: Options<SendEmailVerificationCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SendEmailVerificationCreateResponse, SendEmailVerificationCreateError, ThrowOnError>({
            ...options,
            url: '/api/send-email-verification/'
        });
    }
    
    public static sendMfaRecoveryCodeCreate<ThrowOnError extends boolean = true>(options: Options<SendMfaRecoveryCodeCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SendMfaRecoveryCodeCreateResponse, SendMfaRecoveryCodeCreateError, ThrowOnError>({
            ...options,
            url: '/api/send-mfa-recovery-code/'
        });
    }
    
    /**
     * Endpoint used to notify customers mentioned in comments.
     */
    public static sendSceneCommentMentionEmailCreate<ThrowOnError extends boolean = true>(options: Options<SendSceneCommentMentionEmailCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SendSceneCommentMentionEmailCreateResponse, SendSceneCommentMentionEmailCreateError, ThrowOnError>({
            ...options,
            url: '/api/send_scene_comment_mention_email/'
        });
    }
    
    public static shareGptFeedbackCreate<ThrowOnError extends boolean = true>(options: Options<ShareGptFeedbackCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ShareGptFeedbackCreateResponse, ShareGptFeedbackCreateError, ThrowOnError>({
            ...options,
            url: '/api/share-gpt-feedback/'
        });
    }
    
    public static simpleTextCorrectionCreate<ThrowOnError extends boolean = true>(options: Options<SimpleTextCorrectionCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SimpleTextCorrectionCreateResponse, SimpleTextCorrectionCreateError, ThrowOnError>({
            ...options,
            url: '/api/simple-text-correction/'
        });
    }
    
    /**
     * API endpoint that returns sketch context information including template options,
     * blueprint options, and user video history.
     */
    public static sketchContextInfoRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<SketchContextInfoRetrieveResponse, SketchContextInfoRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/sketch/context/info/'
        });
    }
    
    /**
     * This endpoint executes sketch research workflow.
     */
    public static sketchResearchCreate<ThrowOnError extends boolean = true>(options: Options<SketchResearchCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SketchResearchCreateResponse, SketchResearchCreateError, ThrowOnError>({
            ...options,
            url: '/api/sketch/research/'
        });
    }
    
    /**
     * This endpoint fetches content from user message
     */
    public static sketchUrlFetchCreate<ThrowOnError extends boolean = true>(options: Options<SketchUrlFetchCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SketchUrlFetchCreateResponse, SketchUrlFetchCreateError, ThrowOnError>({
            ...options,
            url: '/api/sketch/url-fetch/'
        });
    }
    
    /**
     * This endpoint takes a list of video plans and validates them
     * using the existing VideoPlanValidator logic. It returns either validated
     * VideoPlan objects or detailed error messages.
     */
    public static sketchValidateVideoPlansCreate<ThrowOnError extends boolean = true>(options: Options<SketchValidateVideoPlansCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SketchValidateVideoPlansCreateResponse, SketchValidateVideoPlansCreateError, ThrowOnError>({
            ...options,
            url: '/api/sketch/validate-video-plans/'
        });
    }
    
    /**
     * This endpoint allows users to search for images using Google Custom Search API
     * and returns asset UUIDs for the found images that can be used in video generation.
     */
    public static sketchWebImageSearchCreate<ThrowOnError extends boolean = true>(options: Options<SketchWebImageSearchCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SketchWebImageSearchCreateResponse, SketchWebImageSearchCreateError, ThrowOnError>({
            ...options,
            url: '/api/sketch/web-image-search/'
        });
    }
    
    public static ssoIdpConfigCreate<ThrowOnError extends boolean = true>(options: Options<SsoIdpConfigCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SsoIdpConfigCreateResponse, SsoIdpConfigCreateError, ThrowOnError>({
            ...options,
            url: '/api/sso-idp-config/'
        });
    }
    
    public static ssoIdpConfigRetrieve<ThrowOnError extends boolean = true>(options: Options<SsoIdpConfigRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<SsoIdpConfigRetrieveResponse, SsoIdpConfigRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/sso-idp-config/{id}/'
        });
    }
    
    public static ssoIdpConfigUpdate<ThrowOnError extends boolean = true>(options: Options<SsoIdpConfigUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<SsoIdpConfigUpdateResponse, SsoIdpConfigUpdateError, ThrowOnError>({
            ...options,
            url: '/api/sso-idp-config/{id}/'
        });
    }
    
    public static ssoIdpConfigPartialUpdate<ThrowOnError extends boolean = true>(options: Options<SsoIdpConfigPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<SsoIdpConfigPartialUpdateResponse, SsoIdpConfigPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/sso-idp-config/{id}/'
        });
    }
    
    public static ssoIdpConfigDestroy<ThrowOnError extends boolean = true>(options: Options<SsoIdpConfigDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<SsoIdpConfigDestroyResponse, SsoIdpConfigDestroyError, ThrowOnError>({
            ...options,
            url: '/api/sso-idp-config/{id}/'
        });
    }
    
    /**
     * Check if the user can signup/login with SSO
     */
    public static ssoVerficationCreate<ThrowOnError extends boolean = true>(options?: Options<SsoVerficationCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SsoVerficationCreateResponse, SsoVerficationCreateError, ThrowOnError>({
            ...options,
            url: '/api/sso-verfication/'
        });
    }
    
    public static submitFeedbackCreate<ThrowOnError extends boolean = true>(options: Options<SubmitFeedbackCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SubmitFeedbackCreateResponse, SubmitFeedbackCreateError, ThrowOnError>({
            ...options,
            url: '/api/submit-feedback/'
        });
    }
    
    /**
     * A simple ViewSet for viewing suggested blueprints
     */
    public static suggestedBlueprintsList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<SuggestedBlueprintsListResponse, SuggestedBlueprintsListError, ThrowOnError>({
            ...options,
            url: '/api/suggested-blueprints/'
        });
    }
    
    /**
     * A simple ViewSet for viewing suggested blueprints
     */
    public static suggestedBlueprintsRetrieve<ThrowOnError extends boolean = true>(options: Options<SuggestedBlueprintsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<SuggestedBlueprintsRetrieveResponse, SuggestedBlueprintsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/suggested-blueprints/{id}/'
        });
    }
    
    public static suggestedMediaCreate<ThrowOnError extends boolean = true>(options: Options<SuggestedMediaCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SuggestedMediaCreateResponse, SuggestedMediaCreateError, ThrowOnError>({
            ...options,
            url: '/api/suggested-media/'
        });
    }
    
    /**
     * Returns the list of languages supported by Lumen5.
     */
    public static supportedLanguagesList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<SupportedLanguagesListResponse, SupportedLanguagesListError, ThrowOnError>({
            ...options,
            url: '/api/supported-languages/'
        });
    }
    
    public static taskResultRetrieve<ThrowOnError extends boolean = true>(options: Options<TaskResultRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<TaskResultRetrieveResponse, TaskResultRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/task-result/{task_id}/'
        });
    }
    
    /**
     * Revokes a task and marks the corresponding partial_result as revoked
     * Required params:
     * - task_id: the ID of the task to delete the partial result for
     */
    public static taskResultDestroy<ThrowOnError extends boolean = true>(options: Options<TaskResultDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<TaskResultDestroyResponse, TaskResultDestroyError, ThrowOnError>({
            ...options,
            url: '/api/task-result/{task_id}/'
        });
    }
    
    public static taskResultsList<ThrowOnError extends boolean = true>(options: Options<TaskResultsListData, ThrowOnError>) {
        return (options?.client ?? client).get<TaskResultsListResponse, TaskResultsListError, ThrowOnError>({
            ...options,
            url: '/api/task-results/'
        });
    }
    
    public static teamInvitationsList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<TeamInvitationsListResponse, TeamInvitationsListError, ThrowOnError>({
            ...options,
            url: '/api/team-invitations/'
        });
    }
    
    public static teamInvitationsCreate<ThrowOnError extends boolean = true>(options: Options<TeamInvitationsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TeamInvitationsCreateResponse, TeamInvitationsCreateError, ThrowOnError>({
            ...options,
            url: '/api/team-invitations/'
        });
    }
    
    public static teamInvitationsRetrieve<ThrowOnError extends boolean = true>(options: Options<TeamInvitationsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<TeamInvitationsRetrieveResponse, TeamInvitationsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/team-invitations/{id}/'
        });
    }
    
    public static teamInvitationsDestroy<ThrowOnError extends boolean = true>(options: Options<TeamInvitationsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<TeamInvitationsDestroyResponse, TeamInvitationsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/team-invitations/{id}/'
        });
    }
    
    public static teamInvitationsResendCreate<ThrowOnError extends boolean = true>(options: Options<TeamInvitationsResendCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TeamInvitationsResendCreateResponse, TeamInvitationsResendCreateError, ThrowOnError>({
            ...options,
            url: '/api/team-invitations/{id}/resend/'
        });
    }
    
    /**
     * NOTE: This endpoint's detail view acts on the User model, not the UserProfile model!
     * So any ids/pks are of the User object!
     */
    public static teamMembersList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<TeamMembersListResponse, TeamMembersListError, ThrowOnError>({
            ...options,
            url: '/api/team-members/'
        });
    }
    
    /**
     * NOTE: This endpoint's detail view acts on the User model, not the UserProfile model!
     * So any ids/pks are of the User object!
     */
    public static teamMembersUpdate<ThrowOnError extends boolean = true>(options: Options<TeamMembersUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<TeamMembersUpdateResponse, TeamMembersUpdateError, ThrowOnError>({
            ...options,
            url: '/api/team-members/{id}/'
        });
    }
    
    /**
     * NOTE: This endpoint's detail view acts on the User model, not the UserProfile model!
     * So any ids/pks are of the User object!
     */
    public static teamMembersPartialUpdate<ThrowOnError extends boolean = true>(options: Options<TeamMembersPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<TeamMembersPartialUpdateResponse, TeamMembersPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/team-members/{id}/'
        });
    }
    
    /**
     * NOTE: This endpoint's detail view acts on the User model, not the UserProfile model!
     * So any ids/pks are of the User object!
     */
    public static teamMembersDestroy<ThrowOnError extends boolean = true>(options: Options<TeamMembersDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<TeamMembersDestroyResponse, TeamMembersDestroyError, ThrowOnError>({
            ...options,
            url: '/api/team-members/{id}/'
        });
    }
    
    /**
     * NOTE: This endpoint's detail view acts on the User model, not the UserProfile model!
     * So any ids/pks are of the User object!
     */
    public static teamMembersDeleteUserAccountDestroy<ThrowOnError extends boolean = true>(options: Options<TeamMembersDeleteUserAccountDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<TeamMembersDeleteUserAccountDestroyResponse, TeamMembersDeleteUserAccountDestroyError, ThrowOnError>({
            ...options,
            url: '/api/team-members/{id}/delete_user_account/'
        });
    }
    
    /**
     * NOTE: This endpoint's detail view acts on the User model, not the UserProfile model!
     * So any ids/pks are of the User object!
     */
    public static teamMembersTwoFactorAuthenticationRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<TeamMembersTwoFactorAuthenticationRetrieveResponse, TeamMembersTwoFactorAuthenticationRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/team-members/two_factor_authentication/'
        });
    }
    
    /**
     * NOTE: This endpoint's detail view acts on the User model, not the UserProfile model!
     * So any ids/pks are of the User object!
     */
    public static teamMembersTwoFactorAuthenticationCreate<ThrowOnError extends boolean = true>(options: Options<TeamMembersTwoFactorAuthenticationCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TeamMembersTwoFactorAuthenticationCreateResponse, TeamMembersTwoFactorAuthenticationCreateError, ThrowOnError>({
            ...options,
            url: '/api/team-members/two_factor_authentication/'
        });
    }
    
    /**
     * Get the Team details and capabilities
     */
    public static teamSettingsRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<TeamSettingsRetrieveResponse, TeamSettingsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/team-settings/'
        });
    }
    
    public static teamSettingsPartialUpdate<ThrowOnError extends boolean = true>(options?: Options<TeamSettingsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<TeamSettingsPartialUpdateResponse, TeamSettingsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/team-settings/'
        });
    }
    
    /**
     * API endpoint that allows template categories to be viewed or deleted
     */
    public static templateCategoriesList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<TemplateCategoriesListResponse, TemplateCategoriesListError, ThrowOnError>({
            ...options,
            url: '/api/template-categories/'
        });
    }
    
    /**
     * API endpoint that returns template information including IDs, aspect ratios, and descriptions.
     * Returns the same data structure as get_template_options with custom_templates, public_templates, and template_ids.
     */
    public static templateInfoList<ThrowOnError extends boolean = true>(options?: Options<TemplateInfoListData, ThrowOnError>) {
        return (options?.client ?? client).get<TemplateInfoListResponse, TemplateInfoListError, ThrowOnError>({
            ...options,
            url: '/api/template-info/'
        });
    }
    
    /**
     * API endpoint that allows templates to be viewed or edited.
     */
    public static templatesList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<TemplatesListResponse, TemplatesListError, ThrowOnError>({
            ...options,
            url: '/api/templates/'
        });
    }
    
    /**
     * API endpoint that allows templates to be viewed or edited.
     */
    public static templatesCreate<ThrowOnError extends boolean = true>(options: Options<TemplatesCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TemplatesCreateResponse, TemplatesCreateError, ThrowOnError>({
            ...options,
            url: '/api/templates/'
        });
    }
    
    /**
     * API endpoint that allows templates to be viewed or edited.
     */
    public static templatesRetrieve<ThrowOnError extends boolean = true>(options: Options<TemplatesRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<TemplatesRetrieveResponse, TemplatesRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/templates/{id}/'
        });
    }
    
    /**
     * API endpoint that allows templates to be viewed or edited.
     */
    public static templatesUpdate<ThrowOnError extends boolean = true>(options: Options<TemplatesUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<TemplatesUpdateResponse, TemplatesUpdateError, ThrowOnError>({
            ...options,
            url: '/api/templates/{id}/'
        });
    }
    
    /**
     * API endpoint that allows templates to be viewed or edited.
     */
    public static templatesPartialUpdate<ThrowOnError extends boolean = true>(options: Options<TemplatesPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<TemplatesPartialUpdateResponse, TemplatesPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/templates/{id}/'
        });
    }
    
    /**
     * API endpoint that allows templates to be viewed or edited.
     */
    public static templatesDestroy<ThrowOnError extends boolean = true>(options: Options<TemplatesDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<TemplatesDestroyResponse, TemplatesDestroyError, ThrowOnError>({
            ...options,
            url: '/api/templates/{id}/'
        });
    }
    
    /**
     * API endpoint that allows display groups to be created, edited or listed
     */
    public static templatesDisplayGroupsList<ThrowOnError extends boolean = true>(options: Options<TemplatesDisplayGroupsListData, ThrowOnError>) {
        return (options?.client ?? client).get<TemplatesDisplayGroupsListResponse, TemplatesDisplayGroupsListError, ThrowOnError>({
            ...options,
            url: '/api/templates/{template_pk}/display-groups/'
        });
    }
    
    /**
     * API endpoint that allows display groups to be created, edited or listed
     */
    public static templatesDisplayGroupsCreate<ThrowOnError extends boolean = true>(options: Options<TemplatesDisplayGroupsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TemplatesDisplayGroupsCreateResponse, TemplatesDisplayGroupsCreateError, ThrowOnError>({
            ...options,
            url: '/api/templates/{template_pk}/display-groups/'
        });
    }
    
    /**
     * API endpoint that allows display groups to be created, edited or listed
     */
    public static templatesDisplayGroupsRetrieve<ThrowOnError extends boolean = true>(options: Options<TemplatesDisplayGroupsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<TemplatesDisplayGroupsRetrieveResponse, TemplatesDisplayGroupsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/templates/{template_pk}/display-groups/{id}/'
        });
    }
    
    /**
     * API endpoint that allows display groups to be created, edited or listed
     */
    public static templatesDisplayGroupsPartialUpdate<ThrowOnError extends boolean = true>(options: Options<TemplatesDisplayGroupsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<TemplatesDisplayGroupsPartialUpdateResponse, TemplatesDisplayGroupsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/templates/{template_pk}/display-groups/{id}/'
        });
    }
    
    /**
     * API endpoint that allows display groups to be created, edited or listed
     */
    public static templatesDisplayGroupsOrderPartialUpdate<ThrowOnError extends boolean = true>(options: Options<TemplatesDisplayGroupsOrderPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<TemplatesDisplayGroupsOrderPartialUpdateResponse, TemplatesDisplayGroupsOrderPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/templates/{template_pk}/display-groups/order/'
        });
    }
    
    public static textToVoiceoverAssetCreate<ThrowOnError extends boolean = true>(options: Options<TextToVoiceoverAssetCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TextToVoiceoverAssetCreateResponse, TextToVoiceoverAssetCreateError, ThrowOnError>({
            ...options,
            url: '/api/text-to-voiceover-asset/'
        });
    }
    
    public static textTranslateCreate<ThrowOnError extends boolean = true>(options: Options<TextTranslateCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TextTranslateCreateResponse, TextTranslateCreateError, ThrowOnError>({
            ...options,
            url: '/api/text-translate/'
        });
    }
    
    public static topUploadsTagsRetrieve<ThrowOnError extends boolean = true>(options: Options<TopUploadsTagsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<TopUploadsTagsRetrieveResponse, TopUploadsTagsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/top-uploads-tags/'
        });
    }
    
    /**
     * This endpoint generates the clip given the transcript, clip plan, and language code.
     */
    public static transcriptClipCreate<ThrowOnError extends boolean = true>(options: Options<TranscriptClipCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TranscriptClipCreateResponse, TranscriptClipCreateError, ThrowOnError>({
            ...options,
            url: '/api/transcript-clip/'
        });
    }
    
    public static transitionedAssetErrorCreate<ThrowOnError extends boolean = true>(options: Options<TransitionedAssetErrorCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TransitionedAssetErrorCreateResponse, TransitionedAssetErrorCreateError, ThrowOnError>({
            ...options,
            url: '/api/transitioned-asset-error/'
        });
    }
    
    /**
     * Creates a new video from an existing video but with a different template.
     */
    public static transmogVideoCreate<ThrowOnError extends boolean = true>(options: Options<TransmogVideoCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TransmogVideoCreateResponse, TransmogVideoCreateError, ThrowOnError>({
            ...options,
            url: '/api/transmog-video/'
        });
    }
    
    /**
     * Creates a resumable upload session to the user's gcs bucket.
     */
    public static uploadUrlsCreate<ThrowOnError extends boolean = true>(options: Options<UploadUrlsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<UploadUrlsCreateResponse, UploadUrlsCreateError, ThrowOnError>({
            ...options,
            url: '/api/upload-urls/'
        });
    }
    
    /**
     * The endpoint for updating media asset metadata.
     */
    public static uploadsMetadataUpdateUpdate<ThrowOnError extends boolean = true>(options: Options<UploadsMetadataUpdateUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<UploadsMetadataUpdateUpdateResponse, UploadsMetadataUpdateUpdateError, ThrowOnError>({
            ...options,
            url: '/api/uploads-metadata-update/'
        });
    }
    
    /**
     * Get a team's usage limit
     */
    public static usageLimitsRetrieve<ThrowOnError extends boolean = true>(options?: Options<UsageLimitsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<UsageLimitsRetrieveResponse, UsageLimitsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/usage_limits/'
        });
    }
    
    /**
     * Returns ordered list of templates used in the workspace
     */
    public static usedTemplatesRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<UsedTemplatesRetrieveResponse, UsedTemplatesRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/used-templates/'
        });
    }
    
    /**
     * Retrieve the current user's profile without requiring an ID field.
     */
    public static userRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<UserRetrieveResponse, UserRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/user/'
        });
    }
    
    /**
     * Adds a value to the user.deets.extra_data json field
     */
    public static userExtraDataCreate<ThrowOnError extends boolean = true>(options: Options<UserExtraDataCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<UserExtraDataCreateResponse, UserExtraDataCreateError, ThrowOnError>({
            ...options,
            url: '/api/user/extra_data/'
        });
    }
    
    /**
     * It's possible for users to be in a workspace but not have access to any projects. This's fine for Admin but not for all other
     * user roles, their videos have to be part of a project.
     * This endpoint returns a boolean value indicating if this case is true for the user.
     */
    public static userHasValidProjectInWorkspaceRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<UserHasValidProjectInWorkspaceRetrieveResponse, UserHasValidProjectInWorkspaceRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/user/has-valid-project-in-workspace/'
        });
    }
    
    /**
     * Notification settings for a user. Available through an unauthed-page (unsub) so secured
     * via user_id and email_secret_uuid.
     */
    public static userNotificationsRetrieve<ThrowOnError extends boolean = true>(options: Options<UserNotificationsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<UserNotificationsRetrieveResponse, UserNotificationsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/user/notifications/{user_id}/{email_secret_uuid}/'
        });
    }
    
    /**
     * Notification settings for a user. Available through an unauthed-page (unsub) so secured
     * via user_id and email_secret_uuid.
     */
    public static userNotificationsPartialUpdate<ThrowOnError extends boolean = true>(options: Options<UserNotificationsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<UserNotificationsPartialUpdateResponse, UserNotificationsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/user/notifications/{user_id}/{email_secret_uuid}/'
        });
    }
    
    /**
     * Validate the dataset video
     */
    public static validateDatasetVideoRetrieve<ThrowOnError extends boolean = true>(options: Options<ValidateDatasetVideoRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<ValidateDatasetVideoRetrieveResponse, ValidateDatasetVideoRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/validate-dataset-video/{video_id}/'
        });
    }
    
    /**
     * Retrieves a list of videos given a set of filters and sort
     *
     * This is done in 2 stages:
     * - Stage 1: Fetch only video ids of filtered and sorted videos
     * - Stage 2: Fetch all data for the video ids
     */
    public static videoList<ThrowOnError extends boolean = true>(options?: Options<VideoListData, ThrowOnError>) {
        return (options?.client ?? client).get<VideoListResponse, VideoListError, ThrowOnError>({
            ...options,
            url: '/api/video/'
        });
    }
    
    /**
     * Create a video from scratch
     */
    public static videoCreate<ThrowOnError extends boolean = true>(options: Options<VideoCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideoCreateResponse, VideoCreateError, ThrowOnError>({
            ...options,
            url: '/api/video/'
        });
    }
    
    public static videoApprovalStatusRetrieve<ThrowOnError extends boolean = true>(options: Options<VideoApprovalStatusRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<VideoApprovalStatusRetrieveResponse, VideoApprovalStatusRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/video-approval-status/{video_id}/'
        });
    }
    
    public static videoApprovalStatusUpdate<ThrowOnError extends boolean = true>(options: Options<VideoApprovalStatusUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<VideoApprovalStatusUpdateResponse, VideoApprovalStatusUpdateError, ThrowOnError>({
            ...options,
            url: '/api/video-approval-status/{video_id}/'
        });
    }
    
    public static videoApprovalStatusPartialUpdate<ThrowOnError extends boolean = true>(options: Options<VideoApprovalStatusPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<VideoApprovalStatusPartialUpdateResponse, VideoApprovalStatusPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/video-approval-status/{video_id}/'
        });
    }
    
    /**
     * Endpoint used to interact with VideoComments. This is used for
     * creating new comments, fetching a list of comments and
     * deleting existing comments.
     */
    public static videoCommentList<ThrowOnError extends boolean = true>(options: Options<VideoCommentListData, ThrowOnError>) {
        return (options?.client ?? client).get<VideoCommentListResponse, VideoCommentListError, ThrowOnError>({
            ...options,
            url: '/api/video-comment/'
        });
    }
    
    /**
     * Creates a new video comment.
     *
     * Required params:
     *
     * - video_id: id of the video that the comment will be attached to
     * - message: json object containing the message for the video.
     */
    public static videoCommentCreate<ThrowOnError extends boolean = true>(options: Options<VideoCommentCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideoCommentCreateResponse, VideoCommentCreateError, ThrowOnError>({
            ...options,
            url: '/api/video-comment/'
        });
    }
    
    /**
     * Deletes a video comment.
     *
     * Required params:
     *
     * - comment_id: id of the comment that should be deleted
     */
    public static videoCommentDestroy<ThrowOnError extends boolean = true>(options: Options<VideoCommentDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<VideoCommentDestroyResponse, VideoCommentDestroyError, ThrowOnError>({
            ...options,
            url: '/api/video-comment/{id}/'
        });
    }
    
    public static videoGenerationCreate<ThrowOnError extends boolean = true>(options: Options<VideoGenerationCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideoGenerationCreateResponse, VideoGenerationCreateError, ThrowOnError>({
            ...options,
            url: '/api/video-generation/'
        });
    }
    
    /**
     * Triggers the task to validate a video poster image
     * Params:
     *
     * - bucket: the name of the bucket used
     * - file_name: the filename to validate inside of the bucket
     * - video_id: the id of the video to use the asset as a poster url for
     */
    public static videoPosterValidationUpdate<ThrowOnError extends boolean = true>(options: Options<VideoPosterValidationUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<VideoPosterValidationUpdateResponse, VideoPosterValidationUpdateError, ThrowOnError>({
            ...options,
            url: '/api/video-poster-validation/'
        });
    }
    
    /**
     * Upload GEN-X storyboard JSON to GCS and send to Slack.
     * Independent endpoint for easy removal.
     */
    public static videoUploadGenxStoryboardCreate<ThrowOnError extends boolean = true>(options: Options<VideoUploadGenxStoryboardCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideoUploadGenxStoryboardCreateResponse, VideoUploadGenxStoryboardCreateError, ThrowOnError>({
            ...options,
            url: '/api/video/{id}/upload_genx_storyboard/'
        });
    }
    
    public static videoRetrieve<ThrowOnError extends boolean = true>(options: Options<VideoRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<VideoRetrieveResponse, VideoRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/video/{video_id}/'
        });
    }
    
    /**
     * SAVE EXISTING VIDEO
     * Save video data to the database.
     */
    public static videoUpdate<ThrowOnError extends boolean = true>(options: Options<VideoUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<VideoUpdateResponse, VideoUpdateError, ThrowOnError>({
            ...options,
            url: '/api/video/{video_id}/'
        });
    }
    
    /**
     * Updates a field of the video. Currently only the name and visibility fields are supported.
     */
    public static videoPartialUpdate<ThrowOnError extends boolean = true>(options: Options<VideoPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<VideoPartialUpdateResponse, VideoPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/video/{video_id}/'
        });
    }
    
    /**
     * Calls the groundhog analysis of scripts, detecting the "groundedness" of script
     * sentences to detect potential hallucinations.
     */
    public static videoGroundhogAnalysisCreate<ThrowOnError extends boolean = true>(options: Options<VideoGroundhogAnalysisCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideoGroundhogAnalysisCreateResponse, VideoGroundhogAnalysisCreateError, ThrowOnError>({
            ...options,
            url: '/api/video/{video_id}/groundhog-analysis/'
        });
    }
    
    /**
     * Gets a URL to download a video, if a video has multiple files (VideoRenders), then this
     * returns a task id, which once complete will provide a URL to a zip file containing all videos.
     */
    public static videoShareDownloadRetrieve<ThrowOnError extends boolean = true>(options: Options<VideoShareDownloadRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<VideoShareDownloadRetrieveResponse, VideoShareDownloadRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/video/{video_id}/share/download/'
        });
    }
    
    /**
     * Mark video as downloaded
     */
    public static videoShareDownloadCreate<ThrowOnError extends boolean = true>(options: Options<VideoShareDownloadCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideoShareDownloadCreateResponse, VideoShareDownloadCreateError, ThrowOnError>({
            ...options,
            url: '/api/video/{video_id}/share/download/'
        });
    }
    
    public static videoTextAssetsTranslateCreate<ThrowOnError extends boolean = true>(options: Options<VideoTextAssetsTranslateCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideoTextAssetsTranslateCreateResponse, VideoTextAssetsTranslateCreateError, ThrowOnError>({
            ...options,
            url: '/api/video/{video_id}/text_assets_translate/'
        });
    }
    
    /**
     * Load the translated text of a video. This endpoint is made public on purpose which is being called
     * on the video share page.
     */
    public static videoTranslatedTextList<ThrowOnError extends boolean = true>(options: Options<VideoTranslatedTextListData, ThrowOnError>) {
        return (options?.client ?? client).get<VideoTranslatedTextListResponse, VideoTranslatedTextListError, ThrowOnError>({
            ...options,
            url: '/api/video/{video_id}/translated_text/'
        });
    }
    
    /**
     * Restore a video version by creating a new video with the old state.
     */
    public static videosRestoreCreate<ThrowOnError extends boolean = true>(options: Options<VideosRestoreCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideosRestoreCreateResponse, VideosRestoreCreateError, ThrowOnError>({
            ...options,
            url: '/api/videos/{video_id}/restore/'
        });
    }
    
    /**
     * List available version history for a video from GCS.
     */
    public static videosVersionsRetrieve<ThrowOnError extends boolean = true>(options: Options<VideosVersionsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<VideosVersionsRetrieveResponse, VideosVersionsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/videos/{video_id}/versions/'
        });
    }
    
    /**
     * Get the video_data for a specific version (for preview).
     */
    public static videosVersionsRetrieve2<ThrowOnError extends boolean = true>(options: Options<VideosVersionsRetrieve2Data, ThrowOnError>) {
        return (options?.client ?? client).get<VideosVersionsRetrieve2Response, VideosVersionsRetrieve2Error, ThrowOnError>({
            ...options,
            url: '/api/videos/{video_id}/versions/{generation}/'
        });
    }
    
    /**
     * Manipulate the archived status of multiple videos in a workspace or project.
     */
    public static videosArchiveMultipleVideosUpdate<ThrowOnError extends boolean = true>(options: Options<VideosArchiveMultipleVideosUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<VideosArchiveMultipleVideosUpdateResponse, VideosArchiveMultipleVideosUpdateError, ThrowOnError>({
            ...options,
            url: '/api/videos/archive-multiple-videos/'
        });
    }
    
    /**
     * Bulk publish multiple videos by queuing them for render.
     */
    public static videosBulkPublishCreate<ThrowOnError extends boolean = true>(options: Options<VideosBulkPublishCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideosBulkPublishCreateResponse, VideosBulkPublishCreateError, ThrowOnError>({
            ...options,
            url: '/api/videos/bulk-publish/'
        });
    }
    
    /**
     * This endpoint is used to create a video from a blueprint.
     *
     * Blueprint can be a public blueprint (anyone can access) or a customer-specific blueprint (where access
     * is restricted to users with access to the workspace).
     *
     * Returns the video object created.
     */
    public static videosCreateFromBlueprintCreate<ThrowOnError extends boolean = true>(options: Options<VideosCreateFromBlueprintCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideosCreateFromBlueprintCreateResponse, VideosCreateFromBlueprintCreateError, ThrowOnError>({
            ...options,
            url: '/api/videos/create-from-blueprint/'
        });
    }
    
    public static videosDuplicateVideosCreate<ThrowOnError extends boolean = true>(options: Options<VideosDuplicateVideosCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideosDuplicateVideosCreateResponse, VideosDuplicateVideosCreateError, ThrowOnError>({
            ...options,
            url: '/api/videos/duplicate_videos/'
        });
    }
    
    /**
     * Move multiple videos to a workpsace or project
     */
    public static videosMoveVideosPartialUpdate<ThrowOnError extends boolean = true>(options?: Options<VideosMoveVideosPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<VideosMoveVideosPartialUpdateResponse, VideosMoveVideosPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/videos/move_videos/'
        });
    }
    
    public static workspaceList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<WorkspaceListResponse, WorkspaceListError, ThrowOnError>({
            ...options,
            url: '/api/workspace/'
        });
    }
    
    public static workspaceCreate<ThrowOnError extends boolean = true>(options?: Options<WorkspaceCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<WorkspaceCreateResponse, WorkspaceCreateError, ThrowOnError>({
            ...options,
            url: '/api/workspace/'
        });
    }
    
    /**
     * Get all unique tags used by videos in workspace
     */
    public static workspaceVideoTagsRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<WorkspaceVideoTagsRetrieveResponse, WorkspaceVideoTagsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/workspace-video-tags/'
        });
    }
    
    public static workspaceRetrieve<ThrowOnError extends boolean = true>(options: Options<WorkspaceRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<WorkspaceRetrieveResponse, WorkspaceRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/workspace/{id}/'
        });
    }
    
    public static workspacePartialUpdate<ThrowOnError extends boolean = true>(options: Options<WorkspacePartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<WorkspacePartialUpdateResponse, WorkspacePartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/workspace/{id}/'
        });
    }
    
    public static workspaceDestroy<ThrowOnError extends boolean = true>(options: Options<WorkspaceDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<WorkspaceDestroyResponse, WorkspaceDestroyError, ThrowOnError>({
            ...options,
            url: '/api/workspace/{id}/'
        });
    }
    
    public static workspaceAddMembersCreate<ThrowOnError extends boolean = true>(options: Options<WorkspaceAddMembersCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<WorkspaceAddMembersCreateResponse, WorkspaceAddMembersCreateError, ThrowOnError>({
            ...options,
            url: '/api/workspace/{id}/add_members/'
        });
    }
    
    public static workspaceAnalyticsRetrieve<ThrowOnError extends boolean = true>(options: Options<WorkspaceAnalyticsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<WorkspaceAnalyticsRetrieveResponse, WorkspaceAnalyticsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/workspace/{id}/analytics/'
        });
    }
    
    public static workspaceRemoveMemberDestroy<ThrowOnError extends boolean = true>(options: Options<WorkspaceRemoveMemberDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<WorkspaceRemoveMemberDestroyResponse, WorkspaceRemoveMemberDestroyError, ThrowOnError>({
            ...options,
            url: '/api/workspace/{id}/remove_member/'
        });
    }
    
    /**
     * Check a signup to see if it corresponds to an invitation to a team.
     */
    public static authInvitationRetrieve<ThrowOnError extends boolean = true>(options: Options<AuthInvitationRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AuthInvitationRetrieveResponse, AuthInvitationRetrieveError, ThrowOnError>({
            ...options,
            url: '/auth/invitation/'
        });
    }
    
    /**
     * This endpoint is only available for internal requests (ie. localhost, 127.0.0.1, etc)
     * Get video_data for a video render.
     */
    public static renderVideoRenderDataRetrieve<ThrowOnError extends boolean = true>(options: Options<RenderVideoRenderDataRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<RenderVideoRenderDataRetrieveResponse, RenderVideoRenderDataRetrieveError, ThrowOnError>({
            ...options,
            url: '/render/video-render-data/{video_render_id}/'
        });
    }
    
}